/*
    Shopify variant IDs have been added for the WarmStep product list.
    Confirm IDs before production deployment.
*/
const warmStepProducts = [
    // 120V - 18 inch mats
    { sku: 'WS1512-120B', variantId: '44835729014837', voltage: 120, widthIn: 18, lengthFt: 12, watts: 162, amps: 1.4, coverageSqFt: 18 },
    { sku: 'WS1510-120B', variantId: '44835728326709', voltage: 120, widthIn: 18, lengthFt: 10, watts: 135, amps: 1.2, coverageSqFt: 15 },
    { sku: 'WS1508-120B', variantId: '44835727802421', voltage: 120, widthIn: 18, lengthFt: 8, watts: 108, amps: 0.9, coverageSqFt: 12 },
    { sku: 'WS1506-120B', variantId: '44835727310901', voltage: 120, widthIn: 18, lengthFt: 6, watts: 81, amps: 0.7, coverageSqFt: 9 },
    { sku: 'WS1505-120B', variantId: '44835637100597', voltage: 120, widthIn: 18, lengthFt: 5, watts: 67.5, amps: 0.6, coverageSqFt: 7.5 },
    { sku: 'WS1504-120B', variantId: '44835637067829', voltage: 120, widthIn: 18, lengthFt: 4, watts: 54, amps: 0.5, coverageSqFt: 6 },

    // 120V - 36 inch mats
    { sku: 'WS3012-120B', variantId: '44835735568437', voltage: 120, widthIn: 36, lengthFt: 12, watts: 324, amps: 2.7, coverageSqFt: 36 },
    { sku: 'WS3010-120B', variantId: '44835734749237', voltage: 120, widthIn: 36, lengthFt: 10, watts: 270, amps: 2.3, coverageSqFt: 30 },
    { sku: 'WS3008-120B', variantId: '44835733209141', voltage: 120, widthIn: 36, lengthFt: 8, watts: 216, amps: 1.8, coverageSqFt: 24 },
    { sku: 'WS3006-120B', variantId: '44835732422709', voltage: 120, widthIn: 36, lengthFt: 6, watts: 162, amps: 1.4, coverageSqFt: 18 },
    { sku: 'WS3005-120B', variantId: '44835731865653', voltage: 120, widthIn: 36, lengthFt: 5, watts: 135, amps: 1.2, coverageSqFt: 15 },
    { sku: 'WS3004-120B', variantId: '44839139508277', voltage: 120, widthIn: 36, lengthFt: 4, watts: 108, amps: 0.9, coverageSqFt: 12 },
    { sku: 'WS3003-120B', variantId: '44835730817077', voltage: 120, widthIn: 36, lengthFt: 3, watts: 81, amps: 0.7, coverageSqFt: 9 },
    { sku: 'WS3002-120B', variantId: '44835729637429', voltage: 120, widthIn: 36, lengthFt: 2, watts: 54, amps: 0.5, coverageSqFt: 6 },

    // 240V - 18 inch mats
    { sku: 'WS1524-240B', variantId: '44835738648629', voltage: 240, widthIn: 18, lengthFt: 24, watts: 324, amps: 1.4, coverageSqFt: 36 },
    { sku: 'WS1520-240B', variantId: '44835738517557', voltage: 240, widthIn: 18, lengthFt: 20, watts: 270, amps: 1.2, coverageSqFt: 30 },
    { sku: 'WS1518-240B', variantId: '44835738484789', voltage: 240, widthIn: 18, lengthFt: 18, watts: 243, amps: 1.1, coverageSqFt: 27 },
    { sku: 'WS1516-240B', variantId: '44835738452021', voltage: 240, widthIn: 18, lengthFt: 16, watts: 216, amps: 0.9, coverageSqFt: 24 },
    { sku: 'WS1514-240B', variantId: '44835738320949', voltage: 240, widthIn: 18, lengthFt: 14, watts: 189, amps: 0.8, coverageSqFt: 21 },
    { sku: 'WS1512-240B', variantId: '44835737567285', voltage: 240, widthIn: 18, lengthFt: 12, watts: 162, amps: 0.7, coverageSqFt: 18 },
    { sku: 'WS1510-240B', variantId: '44835736977461', voltage: 240, widthIn: 18, lengthFt: 10, watts: 135, amps: 0.6, coverageSqFt: 15 },
    { sku: 'WS1508-240B', variantId: '44835735994421', voltage: 240, widthIn: 18, lengthFt: 8, watts: 108, amps: 0.5, coverageSqFt: 12 },

    // 240V - 36 inch mats
    { sku: 'WS3024-240B', variantId: '44835739303989', voltage: 240, widthIn: 36, lengthFt: 24, watts: 648, amps: 2.7, coverageSqFt: 72 },
    { sku: 'WS3020-240B', variantId: '44835739271221', voltage: 240, widthIn: 36, lengthFt: 20, watts: 540, amps: 2.3, coverageSqFt: 60 },
    { sku: 'WS3018-240B', variantId: '44835739238453', voltage: 240, widthIn: 36, lengthFt: 18, watts: 486, amps: 2.1, coverageSqFt: 54 },
    { sku: 'WS3016-240B', variantId: '44835739205685', voltage: 240, widthIn: 36, lengthFt: 16, watts: 432, amps: 1.8, coverageSqFt: 48 },
    { sku: 'WS3014-240B', variantId: '44835739140149', voltage: 240, widthIn: 36, lengthFt: 14, watts: 378, amps: 1.6, coverageSqFt: 42 },
    { sku: 'WS3012-240B', variantId: '44803298820149', voltage: 240, widthIn: 36, lengthFt: 12, watts: 324, amps: 1.4, coverageSqFt: 36 },
    { sku: 'WS3010-240B', variantId: '44803299016757', voltage: 240, widthIn: 36, lengthFt: 10, watts: 270, amps: 1.2, coverageSqFt: 30 },
    { sku: 'WS3008-240B', variantId: '44835738878005', voltage: 240, widthIn: 36, lengthFt: 8, watts: 216, amps: 0.9, coverageSqFt: 24 },
    { sku: 'WS3006-240B', variantId: '44835738812469', voltage: 240, widthIn: 36, lengthFt: 6, watts: 162, amps: 0.7, coverageSqFt: 18 },
    { sku: 'WS3005-240B', variantId: '44835738714165', voltage: 240, widthIn: 36, lengthFt: 5, watts: 135, amps: 0.6, coverageSqFt: 15 },
    { sku: 'WS3004-240B', variantId: '44835738681397', voltage: 240, widthIn: 36, lengthFt: 4, watts: 108, amps: 0.5, coverageSqFt: 12 }
];



const thermoFloorProducts = [
    // 120V - 18 inch mats
    { sku: 'TF1512-120', variantId: '44835742613557', voltage: 120, widthIn: 18, lengthFt: 12, watts: 162, amps: 1.4, coverageSqFt: 18 },
    { sku: 'TF1510-120', variantId: '44835742384181', voltage: 120, widthIn: 18, lengthFt: 10, watts: 135, amps: 1.2, coverageSqFt: 15 },
    { sku: 'TF1508-120', variantId: '44835742318645', voltage: 120, widthIn: 18, lengthFt: 8, watts: 108, amps: 0.9, coverageSqFt: 12 },
    { sku: 'TF1506-120', variantId: '44835742253109', voltage: 120, widthIn: 18, lengthFt: 6, watts: 81, amps: 0.7, coverageSqFt: 9 },
    { sku: 'TF1505-120', variantId: '44835741925429', voltage: 120, widthIn: 18, lengthFt: 5, watts: 67.5, amps: 0.6, coverageSqFt: 7.5 },
    { sku: 'TF1504-120', variantId: '44835741892661', voltage: 120, widthIn: 18, lengthFt: 4, watts: 54, amps: 0.5, coverageSqFt: 6 },

    // 120V - 36 inch mats
    { sku: 'TF3012-120', variantId: '44835743989813', voltage: 120, widthIn: 36, lengthFt: 12, watts: 324, amps: 2.7, coverageSqFt: 36 },
    { sku: 'TF3010-120', variantId: '44835743924277', voltage: 120, widthIn: 36, lengthFt: 10, watts: 270, amps: 2.3, coverageSqFt: 30 },
    { sku: 'TF3008-120', variantId: '44835743858741', voltage: 120, widthIn: 36, lengthFt: 8, watts: 216, amps: 1.8, coverageSqFt: 24 },
    { sku: 'TF3006-120', variantId: '44835743039541', voltage: 120, widthIn: 36, lengthFt: 6, watts: 162, amps: 1.4, coverageSqFt: 18 },
    { sku: 'TF3005-120', variantId: '44835742974005', voltage: 120, widthIn: 36, lengthFt: 5, watts: 135, amps: 1.2, coverageSqFt: 15 },
    { sku: 'TF3004-120', variantId: '44835742908469', voltage: 120, widthIn: 36, lengthFt: 4, watts: 108, amps: 0.9, coverageSqFt: 12 },
    { sku: 'TF3003-120', variantId: '44835742875701', voltage: 120, widthIn: 36, lengthFt: 3, watts: 81, amps: 0.7, coverageSqFt: 9 },
    { sku: 'TF3002-120', variantId: '44835742842933', voltage: 120, widthIn: 36, lengthFt: 2, watts: 54, amps: 0.5, coverageSqFt: 6 },

    // 240V - 18 inch mats
    { sku: 'TF1524-240', variantId: '44835742810165', voltage: 240, widthIn: 18, lengthFt: 24, watts: 324, amps: 1.4, coverageSqFt: 36 },
    { sku: 'TF1520-240', variantId: '44835742777397', voltage: 240, widthIn: 18, lengthFt: 20, watts: 270, amps: 1.2, coverageSqFt: 30 },
    { sku: 'TF1518-240', variantId: '44835742744629', voltage: 240, widthIn: 18, lengthFt: 18, watts: 243, amps: 1.1, coverageSqFt: 27 },
    { sku: 'TF1516-240', variantId: '44835742711861', voltage: 240, widthIn: 18, lengthFt: 16, watts: 216, amps: 0.9, coverageSqFt: 24 },
    { sku: 'TF1514-240', variantId: '44835742679093', voltage: 240, widthIn: 18, lengthFt: 14, watts: 189, amps: 0.8, coverageSqFt: 21 },
    { sku: 'TF1512-240', variantId: '44835742646325', voltage: 240, widthIn: 18, lengthFt: 12, watts: 162, amps: 0.7, coverageSqFt: 18 },
    { sku: 'TF1510-240', variantId: '44835742416949', voltage: 240, widthIn: 18, lengthFt: 10, watts: 135, amps: 0.6, coverageSqFt: 15 },
    { sku: 'TF1508-240', variantId: '44835742351413', voltage: 240, widthIn: 18, lengthFt: 8, watts: 108, amps: 0.5, coverageSqFt: 12 },

    // 240V - 36 inch mats
    { sku: 'TF3024-240', variantId: '44835744251957', voltage: 240, widthIn: 36, lengthFt: 24, watts: 648, amps: 2.7, coverageSqFt: 72 },
    { sku: 'TF3020-240', variantId: '44835744219189', voltage: 240, widthIn: 36, lengthFt: 20, watts: 540, amps: 2.3, coverageSqFt: 60 },
    { sku: 'TF3018-240', variantId: '44835744186421', voltage: 240, widthIn: 36, lengthFt: 18, watts: 486, amps: 2.1, coverageSqFt: 54 },
    { sku: 'TF3016-240', variantId: '44835744153653', voltage: 240, widthIn: 36, lengthFt: 16, watts: 432, amps: 1.8, coverageSqFt: 48 },
    { sku: 'TF3014-240', variantId: '44835744120885', voltage: 240, widthIn: 36, lengthFt: 14, watts: 378, amps: 1.6, coverageSqFt: 42 },
    { sku: 'TF3012-240', variantId: '44835744088117', voltage: 240, widthIn: 36, lengthFt: 12, watts: 324, amps: 1.4, coverageSqFt: 36 },
    { sku: 'TF3010-240', variantId: '44835743957045', voltage: 240, widthIn: 36, lengthFt: 10, watts: 270, amps: 1.2, coverageSqFt: 30 },
    { sku: 'TF3008-240', variantId: '44835743891509', voltage: 240, widthIn: 36, lengthFt: 8, watts: 216, amps: 0.9, coverageSqFt: 24 },
    { sku: 'TF3006-240', variantId: '44835743105077', voltage: 240, widthIn: 36, lengthFt: 6, watts: 162, amps: 0.7, coverageSqFt: 18 },
    { sku: 'TF3005-240', variantId: '44835743006773', voltage: 240, widthIn: 36, lengthFt: 5, watts: 135, amps: 0.6, coverageSqFt: 15 },
    { sku: 'TF3004-240', variantId: '44835742941237', voltage: 240, widthIn: 36, lengthFt: 4, watts: 108, amps: 0.5, coverageSqFt: 12 }
];

const productLines = {
    warmstep: {
    key: 'warmstep',
    name: 'WarmStep',
    eyebrow: 'Electric Radiant Floor Heating Mat Calculator',
    title: 'Electric Radiant Floor Heating Mat Calculator',
    headline: '',
    lede: 'Enter room size and voltage to get a recommended electric radiant floor heating mat solution with quantities, estimated coverage, electrical requirements and layout suggestions. This recommendation is for heating mats only; full systems require a thermostat and possibly additional accessories.',
    resultHeading: 'Electric Floor Heating Mat Recommendation',
    products: warmStepProducts,
    allowedInstallTypes: ['Glued', 'Floating', 'Nail Down', 'Nail Assist', 'Glue Assist'],
    supportsPerpendicularInstallNote: true,
    warmStepCalculatorUrl: '/pages/floor-heating-calculator',
    contactUrl: '/pages/contact'
    },
    thermofloor: {
    key: 'thermofloor',
    name: 'ThermoFloor',
    eyebrow: 'Electric Radiant Floor Heating Mat Calculator',
    title: 'Electric Radiant Floor Heating Mat Calculator',
    headline: '',
    lede: 'Enter room size and voltage to get a recommended electric radiant floor heating mat solution with quantities, estimated coverage, electrical requirements and layout suggestions. This recommendation is for heating mats only; full systems require a thermostat and possibly additional accessories.',
    resultHeading: 'Electric Floor Heating Mat Recommendation',
    products: thermoFloorProducts,
    allowedInstallTypes: ['Floating'],
    supportsPerpendicularInstallNote: false,
    warmStepCalculatorUrl: '/pages/floor-heating-calculator',
    contactUrl: '/pages/contact',
    unsupportedInstallHeadline: 'Our WarmStep Heating Mats are recommended for your installation type.',
    unsupportedInstallBody: ''
    }
};

const requestedProductLine = String(
    window.MAT_CALCULATOR_PRODUCT_LINE ||
    new URLSearchParams(window.location.search).get('line') ||
    document.body.dataset.productLine ||
    'warmstep'
).toLowerCase();
const activeProductLine = productLines[requestedProductLine] || productLines.warmstep;

function getResultProductLine(result) {
    const key = result?.productLineKey || result?.layoutOptions?.[0]?.productLineKey || activeProductLine.key;
    return productLines[key] || activeProductLine;
}

// function isLocalOrTestEnvironment() {
//   const host = window.location.hostname || '';
//   return window.location.protocol === 'file:' || host === '' || host === 'localhost' || host === '127.0.0.1';
// }

function appendCalculatorStateToUrl(baseUrl, lineKey) {
    const [urlWithoutHash, hash = ''] = String(baseUrl || '').split('#');
    const separator = urlWithoutHash.includes('?') ? '&' : '?';
    const params = new URLSearchParams();

    params.set('line', lineKey);

    const roomShape = document.getElementById('roomShape')?.value;
    const voltage = document.getElementById('voltage')?.value;
    const installType = document.getElementById('installType')?.value;
    const heatedLength = document.getElementById('heatedLength')?.value;
    const heatedWidth = document.getElementById('heatedWidth')?.value;

    if (roomShape) params.set('roomShape', roomShape);
    if (voltage) params.set('voltage', voltage);
    if (installType) params.set('installType', installType);
    if (heatedLength) params.set('heatedLength', heatedLength);
    if (heatedWidth) params.set('heatedWidth', heatedWidth);

    return `${urlWithoutHash}${separator}${params.toString()}${hash ? `#${hash}` : ''}`;
}

// function getCalculatorLineUrl(lineKey) {
//     if (isLocalOrTestEnvironment()) {
//     const baseUrl = window.location.href.split('?')[0].split('#')[0];
//     return appendCalculatorStateToUrl(baseUrl, lineKey);
//     }

//     if (lineKey === 'warmstep') return appendCalculatorStateToUrl(activeProductLine.warmStepCalculatorUrl || '/pages/floor-heating-calculator', lineKey);
//     if (lineKey === 'thermofloor') return appendCalculatorStateToUrl(activeProductLine.thermoFloorCalculatorUrl || '/pages/floor-heating-calculator', lineKey);
//     return '#';
// }

function getCalculatorLineUrl(lineKey) {
    if (lineKey === 'warmstep') return appendCalculatorStateToUrl(activeProductLine.warmStepCalculatorUrl || '/pages/floor-heating-calculator', lineKey);
    if (lineKey === 'thermofloor') return appendCalculatorStateToUrl(activeProductLine.thermoFloorCalculatorUrl || '/pages/floor-heating-calculator', lineKey);
    return '#';
}

const products = activeProductLine.products;
const settings = {
    maxCoverageByVoltage: { 120: 200, 240: 360 },
    underageTolerance: 0,
    overageTolerance: 0.10,
    maxMatsToTest: 8,
    partialCleanLayoutCoverageTolerance: 0.05
};

const roomShapeEl = document.getElementById('roomShape');
const simpleFields = document.getElementById('simpleFields');
const complexFields = document.getElementById('complexFields');
const systemFields = document.getElementById('systemFields');
const resultsPanel = document.getElementById('resultsPanel');
const calcActions = document.getElementById('calcActions');
const systemNote = document.getElementById('systemNote');
const layoutHelpCta = document.getElementById('layoutHelpCta');
const requiredFieldsError = document.getElementById('requiredFieldsError');
const resultsEl = document.getElementById('results');
let lastRecommendation = null;
let activeLayoutTab = 'recommended';

function requiresPerpendicularLayoutNote(installType) {
    return !!activeProductLine.supportsPerpendicularInstallNote && ['Nail Down', 'Nail Assist', 'Glue Assist'].includes(installType);
}

function isInstallTypeSupported(installType) {
    return activeProductLine.allowedInstallTypes.includes(installType);
}

function buildUnsupportedInstallTypeResult(inputs) {
    return {
    status: activeProductLine.unsupportedInstallHeadline || 'This installation type is not supported for this product line.',
    targetSqFt: inputs.heatedLengthFt && inputs.heatedWidthFt ? inputs.heatedLengthFt * inputs.heatedWidthFt : 0,
    recommendedCoverage: 0,
    totalWatts: 0,
    totalAmps: 0,
    fitSqFt: 0,
    fitPercent: 0,
    voltage: inputs.voltage,
    matCount: 0,
    layoutOrientation: '',
    laneWidthIn: 0,
    maxRunFt: 0,
    laneCapacityIn: 0,
    isSimpleRoom: true,
    roomLengthFt: inputs.heatedLengthFt,
    roomWidthFt: inputs.heatedWidthFt,
    cart: [],
    requiresLayoutReview: false,
    showContactAssistance: false,
    unsupportedInstallType: true,
    installType: inputs.installType,
    warnings: [],
    _candidate: null
    };
}

function applyProductLineContent() {
    document.title = activeProductLine.title;
    const eyebrow = document.querySelector('.eyebrow');
    const headline = document.querySelector('.hero h1');
    const lede = document.querySelector('.lede');
    const resultHeading = document.querySelector('#resultsPanel .panel-header h2');
    const complexCopy = document.querySelector('#complexFields .review-required-box p');

    if (eyebrow) eyebrow.textContent = activeProductLine.eyebrow;
    if (headline) headline.textContent = activeProductLine.headline;
    if (lede) lede.textContent = activeProductLine.lede;
    if (resultHeading) resultHeading.textContent = activeProductLine.resultHeading;
    if (complexCopy) complexCopy.textContent = 'Irregular, angled, or obstructed rooms require manual layout review before a heating mat recommendation can be made.';
}

// Phone auto-formatter
const phoneInput = document.getElementById('layoutPhone');
if (phoneInput) {
    phoneInput.addEventListener('input', function (e) {
        let val = e.target.value.replace(/\D/g, '');
        if (val.startsWith('1')) val = val.slice(1);
        val = val.slice(0, 10);
        let formatted = '+1';
        if (val.length > 0) formatted += ' (' + val.slice(0, 3);
        if (val.length >= 4) formatted += ') ' + val.slice(3, 6);
        if (val.length >= 7) formatted += '-' + val.slice(6, 10);
        e.target.value = formatted === '+1' ? '' : formatted;
        hideFormError(); 
    });

    phoneInput.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && this.value === '+1 (') {
            e.preventDefault();
            this.value = '';
        }
    });
}
function hideFormError() {
    const error = document.querySelector('#layoutHelpModal .form-error-msg');
    if (error) {
        error.remove();
    }
}
function setSelectFromQuery(id, value) {
    const el = document.getElementById(id);
    if (!el || value === null || value === undefined || value === '') return;
    const matchingOption = Array.from(el.options).find(option => option.value === value);
    if (matchingOption) el.value = value;
}

function setInputFromQuery(id, value) {
    const el = document.getElementById(id);
    if (!el || value === null || value === undefined || value === '') return;
    el.value = value;
}

function applyStateFromQueryParams() {
    const params = new URLSearchParams(window.location.search);

    setSelectFromQuery('roomShape', params.get('roomShape'));
    setSelectFromQuery('voltage', params.get('voltage'));
    setSelectFromQuery('installType', params.get('installType'));
    setInputFromQuery('heatedLength', params.get('heatedLength') || params.get('length'));
    setInputFromQuery('heatedWidth', params.get('heatedWidth') || params.get('width'));
}

function shouldAutoGenerateFromQueryParams() {
    const params = new URLSearchParams(window.location.search);
    return params.has('heatedLength') && params.has('heatedWidth') && roomShapeEl.value === 'Open Floor Plan/Rectangular with No Obstacles';
}

function renderEmptyResults() {
    resultsEl.innerHTML = `
    <div class="results-empty">
        <div class="result-help-prompt" style="text-align:left; margin:0;">
        <strong>Need help with your project?</strong>
        Not sure how to measure, which voltage to choose, or which installation type applies? <a href="#" class="layout-help-trigger">Contact Us</a> or call <a href="tel:18003088057">800.308.8057</a> and we can help confirm the right solution. If you have a drawing, sketch, or floor plan, you can send it to us for review.
        </div>
    </div>
    `;
}

applyProductLineContent();

roomShapeEl.addEventListener('change', updateFieldVisibility);
document.getElementById('resetBtn').addEventListener('click', resetForm);
const openLayoutHelpBtn = document.getElementById('openLayoutHelpBtn');
if (openLayoutHelpBtn) openLayoutHelpBtn.addEventListener('click', openLayoutHelpModal);
document.getElementById('openLayoutHelpBtnInline').addEventListener('click', openLayoutHelpModal);
document.addEventListener('click', function (e) {
    const helpLink = e.target.closest('.layout-help-trigger');
    if (helpLink) {
    e.preventDefault();
    openLayoutHelpModal();
    }
});
['roomShape', 'voltage', 'installType'].forEach(id => {
    const el = document.getElementById(id);
    if (el) {
    el.addEventListener('change', function () {
        if (requiredFieldsError) requiredFieldsError.classList.add('hidden');
    });
    }
});
document.getElementById('closeLayoutHelpBtn').addEventListener('click', closeLayoutHelpModal);
document.getElementById('cancelLayoutHelpBtn').addEventListener('click', closeLayoutHelpModal);
document.getElementById('layoutHelpModal').addEventListener('click', function (e) {
    if (e.target.id === 'layoutHelpModal') closeLayoutHelpModal();
});
document.getElementById('layoutHelpForm').addEventListener('submit', handleLayoutHelpSubmit);
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLayoutHelpModal();
});


document.getElementById('calcForm').addEventListener('submit', function (e) {
    e.preventDefault();

    const inputs = readInputs();

    // Validate required fields
    if (!validateRequiredProjectDetails(inputs)) {
        return;
    }

    // Open contact popup for irregular rooms
    if (inputs.roomShape === 'Irregular/Angled/Obstructed') {
        lastRecommendation = null;
        openLayoutHelpModal();
        return;
    }

    // Show loader
    document.getElementById('calcLoaderOverlay').style.display = 'flex';

    setTimeout(function () {

        activeLayoutTab = 'recommended';

        let recommendation;

        // ThermoFloor unsupported install type
        if (
            !isInstallTypeSupported(inputs.installType) &&
            activeProductLine.key === 'thermofloor'
        ) {

            recommendation = generateWarmStepRecommendation(
                inputs,
                productLines.warmstep.products,
                settings,
                productLines.warmstep
            );

            recommendation.productLineKey = 'warmstep';
            recommendation.productSwitchMessage =
                'Our WarmStep Heating Mats are recommended for your installation type.';

            if (recommendation.layoutOptions) {
                recommendation.layoutOptions.forEach(option => {
                    option.productLineKey = 'warmstep';
                    option.productSwitchMessage =
                        recommendation.productSwitchMessage;
                });
            }

        } else {

            // Normal recommendation
            recommendation = generateWarmStepRecommendation(
                inputs,
                products,
                settings,
                activeProductLine
            );

            recommendation.productLineKey = activeProductLine.key;

            if (recommendation.layoutOptions) {
                recommendation.layoutOptions.forEach(option => {
                    option.productLineKey = activeProductLine.key;
                });
            }
        }

        // Render result
        lastRecommendation = recommendation;
        renderResults(recommendation);

        // Hide loader
        document.getElementById('calcLoaderOverlay').style.display = 'none';

        // Scroll to results
        document.getElementById('resultsPanel').scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });

    }, 300);
});

function validateRequiredProjectDetails(inputs) {
    const missingRequiredFields = !inputs.roomShape || !inputs.voltage || !inputs.installType;
    if (requiredFieldsError) {
    requiredFieldsError.classList.toggle('hidden', !missingRequiredFields);
    }
    if (missingRequiredFields) {
    const firstMissing = ['roomShape', 'voltage', 'installType']
        .map(id => document.getElementById(id))
        .find(el => el && !el.value);
    if (firstMissing) firstMissing.focus();
    return false;
    }
    return true;
}

function updateFieldVisibility() {
    const isComplex = roomShapeEl.value === 'Irregular/Angled/Obstructed';
    const simple = !isComplex;
    simpleFields.classList.toggle('hidden', !simple);
    complexFields.classList.toggle('hidden', simple);
    systemFields.classList.toggle('hidden', isComplex);
    resultsPanel.classList.toggle('hidden', isComplex);
    calcActions.classList.toggle('hidden', isComplex);
    systemNote.classList.toggle('hidden', isComplex);
    if (layoutHelpCta) layoutHelpCta.classList.toggle('hidden', isComplex);

    const generateBtn = document.getElementById('generateBtn');
    if (generateBtn) generateBtn.textContent = 'Generate Options';

    if (!simple) {
    lastRecommendation = null;
    renderEmptyResults();
    } else if (!lastRecommendation) {
    renderEmptyResults();
    }
}

function getNumberValue(id) {
    const el = document.getElementById(id);
    return el ? Number(el.value) : 0;
}

function readInputs() {
    const installType = document.getElementById('installType').value;
    return {
    roomShape: document.getElementById('roomShape').value,
    voltage: Number(document.getElementById('voltage').value),
    installType,
    nailDown: requiresPerpendicularLayoutNote(installType),
    heatedLengthFt: Number(document.getElementById('heatedLength').value),
    heatedWidthFt: Number(document.getElementById('heatedWidth').value),
    estimatedSqFt: getNumberValue('estimatedSqFt'),
    longestStraightRunFt: getNumberValue('longestRun'),
    narrowestHeatedWidthIn: getNumberValue('narrowestWidth')
    };
}

function generateWarmStepRecommendation(inputs, products, settings, productLine = activeProductLine) {
    const warnings = [];
    let targetSqFt = 0;
    let maxRun = 0;
    let usableWidthIn = 0;

    if (inputs.roomShape === 'Open Floor Plan/Rectangular with No Obstacles') {
    targetSqFt = inputs.heatedLengthFt * inputs.heatedWidthFt;
    } else {
    targetSqFt = inputs.estimatedSqFt;
    maxRun = inputs.longestStraightRunFt;
    usableWidthIn = inputs.narrowestHeatedWidthIn;
    }

    if (inputs.roomShape === 'Irregular/Angled/Obstructed') {
    return errorResult('Layout review required', [
        `This room type requires manual layout review before a heating mat recommendation can be made. Please use the Contact Us button and include a floor plan, sketch, photo, or marked-up layout so we can work with you on the right mat plan.`,
        `Heating mats cannot be shortened and should not run under permanent fixtures, so obstructed or irregular spaces should be reviewed before ordering.`
    ], targetSqFt || 0, true);
    }

    if (!targetSqFt || targetSqFt <= 0) {
    return errorResult('Enter valid heated area inputs.', warnings, targetSqFt);
    }

    if (!inputs.voltage || ![120, 240].includes(inputs.voltage)) {
    return errorResult('Select either 120V or 240V.', warnings, targetSqFt);
    }

    if (inputs.roomShape === 'Open Floor Plan/Rectangular with No Obstacles') {
    if (!inputs.heatedLengthFt || inputs.heatedLengthFt <= 0 || !inputs.heatedWidthFt || inputs.heatedWidthFt <= 0) {
        return errorResult('Enter heated length and heated width for open rectangular rooms.', warnings, targetSqFt);
    }
    }

    const maxCoverage = settings.maxCoverageByVoltage[inputs.voltage];
    if (targetSqFt > maxCoverage) {
        if (inputs.voltage === 120) { 
            return errorResult('120V Systems are limited to 200 sq ft per thermostat. Please select 240V or Contact Us for Assistance', [], targetSqFt, true, true);
        } else if (inputs.voltage === 240) {
            return errorResult('240V systems can heat up to 360 sq ft per thermostat. If your project is larger, it may need multiple zones, each with its own thermostat.', [], targetSqFt, true, true);
        } else {
            return errorResult('Layout review required', [], targetSqFt, true, true);
        }
    }

    const orientations = [
    {
        name: 'Lengthwise',
        maxRun: inputs.heatedLengthFt,
        laneCapacityIn: inputs.heatedWidthFt * 12
    },
    {
        name: 'Widthwise',
        maxRun: inputs.heatedWidthFt,
        laneCapacityIn: inputs.heatedLengthFt * 12
    }
    ];

    const orientationResults = orientations.map(orientation => {
    const standardOption = buildOrientationRecommendation(inputs, orientation, targetSqFt, products);
    const physicalOption = buildPhysicalAlternateRecommendation(inputs, orientation, targetSqFt, products);
    const repeatedLaneOption = buildRepeatedLaneRecommendation(inputs, orientation, targetSqFt, products);

    // Every rectangular room should try to show both directions. Use the strongest
    // clean option available. The repeated-lane fallback is intentionally narrow:
    // it only considers the same lane pattern repeated across the room, so it
    // can use fewer longer mats such as 3 x 10 plus 3 x 5 instead of splitting
    // everything into short mats.
    return chooseBestAvailableOrientationOption([standardOption, physicalOption, repeatedLaneOption], targetSqFt);
    }).filter(Boolean);

    const viableOrientationResults = orientationResults.filter(option => option.cart && option.cart.length && !option.requiresLayoutReview);

    if (!viableOrientationResults.length) {
    return errorResult('Layout review required', [
        `The entered dimensions do not produce a clean heating mat layout using standard mat sizes. Please contact ThermoSoft for assistance or send us your layout so we can recommend the right mat plan.`,
        `Heating mats cannot be shortened and should not run under permanent fixtures, so final placement should be confirmed before ordering.`
    ], targetSqFt, true, true);
    }

    let recommended = viableOrientationResults[0];
    viableOrientationResults.slice(1).forEach(candidate => {
    if (isBetterOrientationRecommendation(candidate, recommended, targetSqFt)) {
        recommended = candidate;
    }
    });

    let alternate = orientationResults.find(option => option.layoutOrientation !== recommended.layoutOrientation) || null;

    // If the room is square, both orientations may be visually identical but the tool
    // should still show Option 2 so users can compare both directions instead of seeing
    // the alternate disappear.
    if (!alternate && orientationResults.length > 1) {
    alternate = orientationResults.find(option => option !== recommended) || null;
    }

    recommended.productLineKey = productLine.key;
    recommended.optionKey = 'recommended';
    recommended.tabLabel = 'Option #1 Layout';
    recommended.layoutPreviewTitle = 'Option #1 layout concept';

    const layoutOptions = [recommended];
    if (alternate) {
    alternate.productLineKey = productLine.key;
    alternate.optionKey = 'alternate';
    alternate.tabLabel = 'Option #2 Layout';
    alternate.layoutPreviewTitle = alternate.cart && alternate.cart.length ? 'Option #2 layout concept' : 'Alternate layout unavailable';
    layoutOptions.push(alternate);
    }

    return {
    ...recommended,
    productLineKey: productLine.key,
    layoutOptions
    };
}

function buildPhysicalAlternateRecommendation(inputs, orientation, targetSqFt, productList = products) {
    const eligible = productList.filter(p =>
    p.voltage === inputs.voltage &&
    p.lengthFt <= orientation.maxRun &&
    p.widthIn <= orientation.laneCapacityIn
    );

    const best = findBestCleanPhysicalAlternateCart(eligible, targetSqFt, settings, orientation.laneCapacityIn, orientation.maxRun);
    if (!best) return null;

    best.layoutOrientation = orientation.name;
    best.maxRun = orientation.maxRun;
    best.laneCapacityIn = orientation.laneCapacityIn;
    best.layoutDescription = buildSimpleLayoutDescription(inputs, best, orientation);

    const optionWarnings = [best.layoutDescription];
    //optionWarnings.push('Closest practical mat fit shown. When full coverage is not possible with a clean layout, the tool favors a simpler mat plan over adding several short or mixed-width mats for only a small coverage gain. Confirm final placement before ordering.');

    return buildRecommendationFromCandidate(inputs, best, targetSqFt, optionWarnings);
}


function buildRepeatedLaneRecommendation(inputs, orientation, targetSqFt, productList = products) {
    const eligible = productList.filter(p =>
    p.voltage === inputs.voltage &&
    p.lengthFt <= orientation.maxRun &&
    p.widthIn <= orientation.laneCapacityIn
    );

    const best = findBestRepeatedLaneCart(eligible, targetSqFt, settings, orientation.laneCapacityIn, orientation.maxRun);
    if (!best) return null;

    best.layoutOrientation = orientation.name;
    best.maxRun = orientation.maxRun;
    best.laneCapacityIn = orientation.laneCapacityIn;
    best.layoutDescription = buildSimpleLayoutDescription(inputs, best, orientation);

    const optionWarnings = [best.layoutDescription];
    if (best.isPartial) {
    //optionWarnings.push('Closest practical mat fit shown. When full coverage is not possible with a clean layout, the tool favors a simpler mat plan over adding several short or mixed-width mats for only a small coverage gain. Confirm final placement before ordering.');
    }

    return buildRecommendationFromCandidate(inputs, best, targetSqFt, optionWarnings);
}

function chooseBestAvailableOrientationOption(options, targetSqFt) {
    const available = options.filter(option => option && option.cart && option.cart.length);
    if (!available.length) return options.find(Boolean) || null;

    let best = available[0];
    available.slice(1).forEach(candidate => {
    if (isBetterSameDirectionOption(candidate, best, targetSqFt)) {
        best = candidate;
    }
    });

    return best;
}

function isBetterSameDirectionOption(candidate, currentBest, targetSqFt) {
    const candidateFitPct = targetSqFt ? Math.abs(candidate.recommendedCoverage - targetSqFt) / targetSqFt : Infinity;
    const currentFitPct = targetSqFt ? Math.abs(currentBest.recommendedCoverage - targetSqFt) / targetSqFt : Infinity;
    const meaningfulFitDifference = 0.005; // 0.5 percentage points

    if (candidateFitPct + meaningfulFitDifference < currentFitPct) return true;
    if (currentFitPct + meaningfulFitDifference < candidateFitPct) return false;

    // Within the same direction, do not let a single-width 1.5 ft layout beat a
    // cleaner mixed-width fill that achieves the same coverage with far fewer mats.
    if ((candidate.matCount || 0) < (currentBest.matCount || 0)) return true;
    if ((candidate.matCount || 0) > (currentBest.matCount || 0)) return false;

    if ((candidate._candidate?.distinctSkuCount || candidate.cart.length || 0) < (currentBest._candidate?.distinctSkuCount || currentBest.cart.length || 0)) return true;
    if ((candidate._candidate?.distinctSkuCount || candidate.cart.length || 0) > (currentBest._candidate?.distinctSkuCount || currentBest.cart.length || 0)) return false;

    if ((candidate._candidate?.lanePatternTypeCount || 0) < (currentBest._candidate?.lanePatternTypeCount || 0)) return true;
    if ((candidate._candidate?.lanePatternTypeCount || 0) > (currentBest._candidate?.lanePatternTypeCount || 0)) return false;

    if ((candidate._candidate?.widthTypeCount || 0) < (currentBest._candidate?.widthTypeCount || 0)) return true;
    if ((candidate._candidate?.widthTypeCount || 0) > (currentBest._candidate?.widthTypeCount || 0)) return false;

    return (candidate.recommendedCoverage || 0) > (currentBest.recommendedCoverage || 0);
}

function findBestRepeatedLaneCart(eligible, targetSqFt, settings, maxLaneWidthIn, maxRunFt) {
    let best = null;
    const maxAllowedCoverage = targetSqFt * (1 + (settings.overageTolerance || 0));
    const productsByWidth = new Map();

    eligible.forEach(product => {
    if (!productsByWidth.has(product.widthIn)) productsByWidth.set(product.widthIn, []);
    productsByWidth.get(product.widthIn).push(product);
    });

    const patternsByWidth = new Map();

    function considerCandidate(candidate) {
    if (!candidate) return;
    if (candidate.coverage <= 0 || candidate.coverage > maxAllowedCoverage) return;
    if (candidate.laneWidthIn > maxLaneWidthIn + 0.0001) return;

    if (!best || isBetterRepeatedLaneCart(candidate, best, targetSqFt)) {
        best = candidate;
    }
    }

    function mergePatternCart(patternsWithCounts) {
    const grouped = new Map();
    patternsWithCounts.forEach(({ pattern, laneCount }) => {
        pattern.items.forEach(item => {
        const sku = item.product.sku;
        const qtyToAdd = item.qty * laneCount;
        const existing = grouped.get(sku);
        if (existing) {
            existing.qty += qtyToAdd;
            existing.lineCoverageSqFt += item.product.coverageSqFt * qtyToAdd;
        } else {
            grouped.set(sku, {
            ...item.product,
            qty: qtyToAdd,
            lineCoverageSqFt: item.product.coverageSqFt * qtyToAdd
            });
        }
        });
    });

    return Array.from(grouped.values()).sort((a, b) => {
        if (b.widthIn !== a.widthIn) return b.widthIn - a.widthIn;
        return b.lengthFt - a.lengthFt;
    });
    }

    // Same-width repeated lanes. This preserves the original clean-grid behavior.
    productsByWidth.forEach((widthProducts, widthIn) => {
    const maxLaneCount = Math.floor((maxLaneWidthIn + 0.0001) / Number(widthIn));
    if (maxLaneCount <= 0) return;

    const sorted = widthProducts.slice().sort((a, b) => b.lengthFt - a.lengthFt);
    const lanePatterns = buildCleanLanePatterns(sorted, maxRunFt);
    patternsByWidth.set(Number(widthIn), lanePatterns);

    lanePatterns.forEach(pattern => {
        for (let laneCount = 1; laneCount <= maxLaneCount; laneCount++) {
        const coverage = pattern.coverageSqFt * laneCount;
        const laneWidthIn = laneCount * Number(widthIn);
        const cart = mergePatternCart([{ pattern, laneCount }]);
        const matCount = pattern.matCount * laneCount;

        considerCandidate({
            coverage,
            matCount,
            avgCoverage: coverage / matCount,
            laneWidthIn,
            widthTypeCount: 1,
            distinctSkuCount: cart.length,
            laneCount,
            laneFillRangeFt: 0,
            lanePatternTypeCount: 1,
            cart,
            isPartial: coverage < targetSqFt
        });
        }
    });
    });

    // Mixed-width repeated lanes. This is intentionally narrow:
    // use 3 ft lanes as the primary pattern and allow only one 1.5 ft fill lane
    // with the same run length. This catches clean layouts like 3 × 3 ft by 10 ft
    // plus 1 × 1.5 ft by 10 ft, without letting the tool build mostly 1.5 ft lanes.
    const widePatterns = patternsByWidth.get(36) || [];
    const fillPatterns = patternsByWidth.get(18) || [];
    if (widePatterns.length && fillPatterns.length) {
    widePatterns.forEach(widePattern => {
        fillPatterns.forEach(fillPattern => {
        if (Math.abs(widePattern.laneLengthFt - fillPattern.laneLengthFt) > 0.0001) return;

        const maxWideLaneCount = Math.floor((maxLaneWidthIn - 18 + 0.0001) / 36);
        for (let wideLaneCount = 1; wideLaneCount <= maxWideLaneCount; wideLaneCount++) {
            const fillLaneCount = 1;
            const laneWidthIn = (wideLaneCount * 36) + 18;
            if (laneWidthIn > maxLaneWidthIn + 0.0001) continue;

            const coverage = (widePattern.coverageSqFt * wideLaneCount) + fillPattern.coverageSqFt;
            const matCount = (widePattern.matCount * wideLaneCount) + fillPattern.matCount;
            const cart = mergePatternCart([
            { pattern: widePattern, laneCount: wideLaneCount },
            { pattern: fillPattern, laneCount: fillLaneCount }
            ]);

            considerCandidate({
            coverage,
            matCount,
            avgCoverage: coverage / matCount,
            laneWidthIn,
            widthTypeCount: 2,
            distinctSkuCount: cart.length,
            laneCount: wideLaneCount + fillLaneCount,
            laneFillRangeFt: 0,
            lanePatternTypeCount: widePattern.distinctSkuCount === fillPattern.distinctSkuCount && widePattern.laneLengthFt === fillPattern.laneLengthFt ? 1 : 2,
            cart,
            isPartial: coverage < targetSqFt
            });
        }
        });
    });
    }

    return best;
}

function buildCleanLanePatterns(widthProducts, maxRunFt) {
    const patternsByLength = new Map();
    const maxSegmentsPerLane = Math.min(4, Math.floor(maxRunFt / Math.min(...widthProducts.map(p => p.lengthFt))) || 1);

    function addPattern(items) {
    const laneLengthFt = items.reduce((sum, item) => sum + item.lengthFt, 0);
    if (laneLengthFt <= 0 || laneLengthFt > maxRunFt + 0.0001) return;

    const roundedLength = Math.round(laneLengthFt * 1000) / 1000;
    const grouped = new Map();
    items.forEach(product => {
        const existing = grouped.get(product.sku);
        if (existing) existing.qty += 1;
        else grouped.set(product.sku, { product, qty: 1 });
    });

    const pattern = {
        laneLengthFt,
        coverageSqFt: items.reduce((sum, product) => sum + product.coverageSqFt, 0),
        matCount: items.length,
        distinctSkuCount: grouped.size,
        items: Array.from(grouped.values()).sort((a, b) => b.product.lengthFt - a.product.lengthFt)
    };

    const current = patternsByLength.get(roundedLength);
    if (!current || isBetterLanePattern(pattern, current)) {
        patternsByLength.set(roundedLength, pattern);
    }
    }

    function recurse(startIndex, items, lengthSoFar) {
    if (items.length > 0) addPattern(items);
    if (items.length >= maxSegmentsPerLane) return;

    for (let i = startIndex; i < widthProducts.length; i++) {
        const product = widthProducts[i];
        const nextLength = lengthSoFar + product.lengthFt;
        if (nextLength > maxRunFt + 0.0001) continue;
        recurse(i, [...items, product], nextLength);
    }
    }

    recurse(0, [], 0);
    return Array.from(patternsByLength.values());
}

function isBetterLanePattern(candidate, currentBest) {
    if (candidate.matCount < currentBest.matCount) return true;
    if (candidate.matCount > currentBest.matCount) return false;

    if (candidate.distinctSkuCount < currentBest.distinctSkuCount) return true;
    if (candidate.distinctSkuCount > currentBest.distinctSkuCount) return false;

    return candidate.coverageSqFt > currentBest.coverageSqFt;
}

function isBetterRepeatedLaneCart(candidate, currentBest, targetSqFt) {
    const candidateFitPct = targetSqFt ? Math.abs(candidate.coverage - targetSqFt) / targetSqFt : Infinity;
    const currentFitPct = targetSqFt ? Math.abs(currentBest.coverage - targetSqFt) / targetSqFt : Infinity;

    if (candidateFitPct < currentFitPct) return true;
    if (candidateFitPct > currentFitPct) return false;

    const candidateOver = candidate.coverage >= targetSqFt;
    const currentOver = currentBest.coverage >= targetSqFt;
    if (candidateOver && !currentOver) return true;
    if (!candidateOver && currentOver) return false;

    if (candidate.matCount < currentBest.matCount) return true;
    if (candidate.matCount > currentBest.matCount) return false;

    if (candidate.distinctSkuCount < currentBest.distinctSkuCount) return true;
    if (candidate.distinctSkuCount > currentBest.distinctSkuCount) return false;

    return candidate.laneCount < currentBest.laneCount;
}

function findBestCleanPhysicalAlternateCart(eligible, targetSqFt, settings, maxLaneWidthIn, maxRunFt) {
    let best = null;
    const counts = Array(eligible.length).fill(0);

    function recurse(index) {
    if (index === eligible.length) {
        evaluate();
        return;
    }

    for (let q = 0; q <= settings.maxMatsToTest; q++) {
        counts[index] = q;
        if (counts.reduce((a, b) => a + b, 0) <= settings.maxMatsToTest) recurse(index + 1);
    }
    counts[index] = 0;
    }

    function evaluate() {
    let coverage = 0;
    let matCount = 0;
    const cart = [];

    counts.forEach((qty, i) => {
        if (qty > 0) {
        const p = eligible[i];
        matCount += qty;
        coverage += qty * p.coverageSqFt;
        cart.push({ ...p, qty, lineCoverageSqFt: qty * p.coverageSqFt });
        }
    });

    if (matCount === 0) return;
    if (coverage >= targetSqFt) return;

    const laneWidthIn = calculatePackedLaneWidth(cart, maxRunFt);
    if (laneWidthIn > maxLaneWidthIn) return;

    const widthTypeCount = new Set(cart.map(item => item.widthIn)).size;
    const distinctSkuCount = cart.length;
    const laneQuality = getLaneQuality(cart, maxRunFt);

    // This fallback is only for Option 2. It should show a clean physical alternate,
    // including a mostly 3 ft layout plus a single 1.5 ft fill lane when that improves coverage.
    // It should not revive puzzle-piece layouts with several SKUs or uneven lane patterns.
    if (distinctSkuCount > 2) return;
    if (widthTypeCount > 2) return;
    if ((laneQuality.lanePatternTypeCount || 0) > 2) return;
    if ((laneQuality.laneFillRangeFt || 0) > 2) return;

    const candidate = {
        coverage,
        matCount,
        avgCoverage: coverage / matCount,
        laneWidthIn,
        widthTypeCount,
        distinctSkuCount,
        laneCount: laneQuality.laneCount || matCount,
        laneFillRangeFt: laneQuality.laneFillRangeFt || 0,
        lanePatternTypeCount: laneQuality.lanePatternTypeCount || 0,
        cart,
        isPartial: true
    };

    if (!best || isBetterCleanPhysicalAlternate(candidate, best)) {
        best = candidate;
    }
    }

    recurse(0);
    return best;
}

function isBetterCleanPhysicalAlternate(candidate, currentBest) {
    if (candidate.coverage > currentBest.coverage) return true;
    if (candidate.coverage < currentBest.coverage) return false;

    if ((candidate.lanePatternTypeCount || 0) < (currentBest.lanePatternTypeCount || 0)) return true;
    if ((candidate.lanePatternTypeCount || 0) > (currentBest.lanePatternTypeCount || 0)) return false;

    if ((candidate.laneFillRangeFt || 0) < (currentBest.laneFillRangeFt || 0)) return true;
    if ((candidate.laneFillRangeFt || 0) > (currentBest.laneFillRangeFt || 0)) return false;

    if ((candidate.distinctSkuCount || 0) < (currentBest.distinctSkuCount || 0)) return true;
    if ((candidate.distinctSkuCount || 0) > (currentBest.distinctSkuCount || 0)) return false;

    if ((candidate.widthTypeCount || 0) < (currentBest.widthTypeCount || 0)) return true;
    if ((candidate.widthTypeCount || 0) > (currentBest.widthTypeCount || 0)) return false;

    return candidate.matCount < currentBest.matCount;
}

function buildOrientationRecommendation(inputs, orientation, targetSqFt, productList = products) {
    const eligible = productList.filter(p =>
    p.voltage === inputs.voltage &&
    p.lengthFt <= orientation.maxRun &&
    p.widthIn <= orientation.laneCapacityIn
    );

    if (!eligible.length) {
    return buildOrientationUnavailableResult(inputs, orientation, targetSqFt, [
        `This direction does not have eligible heating mats for the selected voltage and dimensions.`
    ]);
    }

    let candidate = findBestCart(eligible, targetSqFt, settings, orientation.laneCapacityIn, orientation.maxRun);
    if (!candidate) {
    candidate = findBestPartialCart(eligible, targetSqFt, settings, orientation.laneCapacityIn, orientation.maxRun);
    if (candidate) candidate.isPartial = true;
    }

    if (!candidate) {
    return buildOrientationUnavailableResult(inputs, orientation, targetSqFt, [
        `This direction does not produce a valid heating mat fit within the current room dimensions and tolerance settings.`
    ]);
    }

    candidate.layoutOrientation = orientation.name;
    candidate.layoutDescription = buildSimpleLayoutDescription(inputs, candidate, orientation);
    candidate.maxRun = orientation.maxRun;
    candidate.laneCapacityIn = orientation.laneCapacityIn;

    if (isPatchworkPartialRecommendation(candidate)) {
    return buildOrientationUnavailableResult(inputs, orientation, targetSqFt, [
        'This direction would require an awkward patchwork-style mat layout, so it should be reviewed by ThermoSoft before ordering.',
        `Heating mats cannot be shortened and should not run under permanent fixtures.`
    ]);
    }

    const optionWarnings = [candidate.layoutDescription];
    if (candidate.isPartial) {
    //optionWarnings.push('Closest practical mat fit shown. When full coverage is not possible with a clean layout, the tool favors a simpler mat plan over adding several short or mixed-width mats for only a small coverage gain. Confirm final placement before ordering.');
    }

    if (orientation.laneCapacityIn < 36 && orientation.laneCapacityIn >= 18) {
    optionWarnings.push('36-inch mats were excluded because the usable heated width in this direction is under 36 inches. The recommendation is limited to 18-inch mats.');
    }

    return buildRecommendationFromCandidate(inputs, candidate, targetSqFt, optionWarnings);
}

function buildRecommendationFromCandidate(inputs, best, targetSqFt, warnings) {
    return {
    status: best.isPartial ? 'Closest physical fit' : 'Valid recommendation',
    targetSqFt,
    recommendedCoverage: best.coverage,
    totalWatts: calculateCartWatts(best.cart),
    totalAmps: calculateCartAmps(best.cart),
    fitSqFt: best.coverage - targetSqFt,
    fitPercent: (best.coverage - targetSqFt) / targetSqFt,
    voltage: inputs.voltage,
    matCount: best.matCount,
    layoutOrientation: best.layoutOrientation,
    laneWidthIn: best.laneWidthIn,
    maxRunFt: best.maxRun,
    laneCapacityIn: best.laneCapacityIn,
    isSimpleRoom: true,
    roomLengthFt: inputs.heatedLengthFt,
    roomWidthFt: inputs.heatedWidthFt,
    cart: best.cart,
    requiresLayoutReview: false,
    showContactAssistance: false,
    nailDown: inputs.nailDown,
    installType: inputs.installType,
    warnings,
    _candidate: best
    };
}

function buildOrientationUnavailableResult(inputs, orientation, targetSqFt, warnings) {
    return {
    status: 'Alternate layout unavailable',
    targetSqFt,
    recommendedCoverage: 0,
    totalWatts: 0,
    totalAmps: 0,
    fitSqFt: 0,
    fitPercent: 0,
    voltage: inputs.voltage,
    matCount: 0,
    layoutOrientation: orientation.name,
    laneWidthIn: 0,
    maxRunFt: orientation.maxRun,
    laneCapacityIn: orientation.laneCapacityIn,
    isSimpleRoom: true,
    roomLengthFt: inputs.heatedLengthFt,
    roomWidthFt: inputs.heatedWidthFt,
    cart: [],
    requiresLayoutReview: false,
    showContactAssistance: true,
    nailDown: inputs.nailDown,
    installType: inputs.installType,
    warnings,
    _candidate: null
    };
}

function isBetterOrientationRecommendation(candidate, currentBest, targetSqFt) {
    if (candidate.cart.length && !currentBest.cart.length) return true;
    if (!candidate.cart.length && currentBest.cart.length) return false;

    const candidateFitPct = targetSqFt ? Math.abs(candidate.recommendedCoverage - targetSqFt) / targetSqFt : Infinity;
    const currentFitPct = targetSqFt ? Math.abs(currentBest.recommendedCoverage - targetSqFt) / targetSqFt : Infinity;
    const meaningfulFitDifference = 0.005; // 0.5 percentage points

    // When both orientations produce clean physical layouts, choose the one that is
    // closest to the requested heated area. Cleanliness remains the tiebreaker.
    if (candidateFitPct + meaningfulFitDifference < currentFitPct) return true;
    if (currentFitPct + meaningfulFitDifference < candidateFitPct) return false;

    const candidatePartial = !!(candidate._candidate && candidate._candidate.isPartial);
    const currentPartial = !!(currentBest._candidate && currentBest._candidate.isPartial);
    if (!candidatePartial && currentPartial) return true;
    if (candidatePartial && !currentPartial) return false;

    if (candidatePartial && currentPartial) {
    return isBetterPartialCart(candidate._candidate, currentBest._candidate, targetSqFt);
    }

    return isBetterCart(candidate._candidate, currentBest._candidate, targetSqFt);
}

function buildSimpleLayoutDescription(inputs, candidate, orientation) {
    const runFt = orientation.maxRun;
    const laneWidthFt = candidate.laneWidthIn ? candidate.laneWidthIn / 12 : candidate.coverage / runFt;
    const areaLabel = `${formatNumber(runFt)} ft × ${formatNumber(laneWidthFt)} ft`;
    const directionLabel = orientation.name === 'Lengthwise'
    ? `${formatNumber(inputs.heatedLengthFt)} ft dimension`
    : `${formatNumber(inputs.heatedWidthFt)} ft dimension`;

    let message = `Suggested layout: mats run along the ${directionLabel}. Estimated heated footprint: about ${areaLabel} (${formatNumber(candidate.coverage)} sq ft).`;

    if (candidate.isPartial) {
    message += ' This is the closest physical mat fit based on the available mat sizes and your room dimensions; confirm final placement before ordering.';
    } else {
    message += ' This tool compares both mat directions and selects the best physical fit based on available mat sizes.';
    }

    message += ' Mats cannot be shortened. ';
    message += '<br><strong>This recommendation is for heating mats only and is intended as a planning estimate, not a guarantee of fit or a final installation plan. Please confirm all mat sizes, quantities, placement, thermostat requirements, and accessories before completing your purchase.</strong> '
    return message;
}

function getLaneQuality(cart, maxRunFt) {
    if (!maxRunFt || !cart || !cart.length) {
    return { laneCount: 0, laneFillRangeFt: 0, lanePatternTypeCount: 0 };
    }

    const lanes = packMatsIntoPreviewLanes(cart, maxRunFt);
    if (!lanes.length) {
    return { laneCount: 0, laneFillRangeFt: 0, lanePatternTypeCount: 0 };
    }

    const fills = lanes.map(lane => lane.totalLengthFt);
    const laneFillRangeFt = Math.max(...fills) - Math.min(...fills);
    const lanePatternTypeCount = new Set(lanes.map(lane =>
    lane.mats
        .map(mat => `${mat.widthIn}x${mat.lengthFt}`)
        .sort()
        .join('+')
    )).size;

    return { laneCount: lanes.length, laneFillRangeFt, lanePatternTypeCount };
}

function isPatchworkPartialRecommendation(candidate) {
    if (!candidate || !candidate.isPartial || !candidate.cart || !candidate.cart.length) return false;

    const matCount = candidate.matCount || candidate.cart.reduce((sum, item) => sum + (item.qty || 0), 0);
    const distinctSkuCount = candidate.distinctSkuCount || candidate.cart.length;
    const widthTypeCount = candidate.widthTypeCount || new Set(candidate.cart.map(item => item.widthIn)).size;
    const lanePatternTypeCount = candidate.lanePatternTypeCount || 0;
    const laneFillRangeFt = candidate.laneFillRangeFt || 0;

    // Guardrail: do not present a strange puzzle-piece cart for an open rectangular room.
    // If the only close-ish fit requires several SKUs, mixed widths, or uneven lane patterns,
    // move the customer to layout review instead of encouraging an order from an awkward cart.
    return matCount >= 6 && (
    distinctSkuCount >= 3 ||
    widthTypeCount > 1 ||
    lanePatternTypeCount >= 3 ||
    laneFillRangeFt > 2
    );
}

function isBetterCart(candidate, currentBest, targetSqFt) {
    if (candidate.matCount < currentBest.matCount) return true;
    if (candidate.matCount > currentBest.matCount) return false;

    const candidateFit = Math.abs(candidate.coverage - targetSqFt);
    const bestFit = Math.abs(currentBest.coverage - targetSqFt);
    if (candidateFit < bestFit) return true;
    if (candidateFit > bestFit) return false;

    // If coverage and mat count tie, choose the cleaner physical layout.
    // This avoids odd-looking recommendations that mix an 18" lane into a layout
    // when an all-36" solution with the same coverage and same mat count exists.
    if ((candidate.widthTypeCount || 0) < (currentBest.widthTypeCount || 0)) return true;
    if ((candidate.widthTypeCount || 0) > (currentBest.widthTypeCount || 0)) return false;

    if ((candidate.distinctSkuCount || 0) < (currentBest.distinctSkuCount || 0)) return true;
    if ((candidate.distinctSkuCount || 0) > (currentBest.distinctSkuCount || 0)) return false;

    if ((candidate.laneCount || 0) < (currentBest.laneCount || 0)) return true;
    if ((candidate.laneCount || 0) > (currentBest.laneCount || 0)) return false;

    if ((candidate.lanePatternTypeCount || 0) < (currentBest.lanePatternTypeCount || 0)) return true;
    if ((candidate.lanePatternTypeCount || 0) > (currentBest.lanePatternTypeCount || 0)) return false;

    if ((candidate.laneFillRangeFt || 0) < (currentBest.laneFillRangeFt || 0)) return true;
    if ((candidate.laneFillRangeFt || 0) > (currentBest.laneFillRangeFt || 0)) return false;

    return candidate.avgCoverage > currentBest.avgCoverage;
}

function findBestCart(eligible, targetSqFt, settings, maxLaneWidthIn = null, maxRunFt = null) {
    const minCoverage = targetSqFt * (1 - settings.underageTolerance);
    const maxCoverage = targetSqFt * (1 + settings.overageTolerance);
    let best = null;
    const counts = Array(eligible.length).fill(0);

    function recurse(index) {
    if (index === eligible.length) {
        evaluate();
        return;
    }
    for (let q = 0; q <= settings.maxMatsToTest; q++) {
        counts[index] = q;
        if (counts.reduce((a, b) => a + b, 0) <= settings.maxMatsToTest) recurse(index + 1);
    }
    counts[index] = 0;
    }

    function evaluate() {
    let coverage = 0;
    let matCount = 0;
    let laneWidthIn = 0;
    const cart = [];

    counts.forEach((qty, i) => {
        if (qty > 0) {
        const p = eligible[i];
        matCount += qty;
        coverage += qty * p.coverageSqFt;
        laneWidthIn += qty * p.widthIn;
        cart.push({ ...p, qty, lineCoverageSqFt: qty * p.coverageSqFt });
        }
    });

    if (matCount === 0 || coverage < minCoverage || coverage > maxCoverage) return;
    if (maxLaneWidthIn && maxRunFt) {
        laneWidthIn = calculatePackedLaneWidth(cart, maxRunFt);
        if (laneWidthIn > maxLaneWidthIn) return;
    } else if (maxLaneWidthIn && laneWidthIn > maxLaneWidthIn) return;

    const avgCoverage = coverage / matCount;
    const widthTypeCount = new Set(cart.map(item => item.widthIn)).size;
    const distinctSkuCount = cart.length;
    const laneQuality = getLaneQuality(cart, maxRunFt);
    const candidate = {
        coverage,
        matCount,
        avgCoverage,
        laneWidthIn,
        widthTypeCount,
        distinctSkuCount,
        laneCount: laneQuality.laneCount || matCount,
        laneFillRangeFt: laneQuality.laneFillRangeFt || 0,
        lanePatternTypeCount: laneQuality.lanePatternTypeCount || 0,
        cart
    };

    if (!best || isBetterCart(candidate, best, targetSqFt)) {
        best = candidate;
    }
    }

    recurse(0);
    return best;
}

function findBestPartialCart(eligible, targetSqFt, settings, maxLaneWidthIn = null, maxRunFt = null) {
    let best = null;
    const counts = Array(eligible.length).fill(0);

    function recurse(index) {
    if (index === eligible.length) {
        evaluate();
        return;
    }
    for (let q = 0; q <= settings.maxMatsToTest; q++) {
        counts[index] = q;
        if (counts.reduce((a, b) => a + b, 0) <= settings.maxMatsToTest) recurse(index + 1);
    }
    counts[index] = 0;
    }

    function evaluate() {
    let coverage = 0;
    let matCount = 0;
    let laneWidthIn = 0;
    const cart = [];

    counts.forEach((qty, i) => {
        if (qty > 0) {
        const p = eligible[i];
        matCount += qty;
        coverage += qty * p.coverageSqFt;
        laneWidthIn += qty * p.widthIn;
        cart.push({ ...p, qty, lineCoverageSqFt: qty * p.coverageSqFt });
        }
    });

    if (matCount === 0) return;
    if (coverage >= targetSqFt) return;

    if (maxLaneWidthIn && maxRunFt) {
        laneWidthIn = calculatePackedLaneWidth(cart, maxRunFt);
        if (laneWidthIn > maxLaneWidthIn) return;
    } else if (maxLaneWidthIn && laneWidthIn > maxLaneWidthIn) return;

    const avgCoverage = coverage / matCount;
    const widthTypeCount = new Set(cart.map(item => item.widthIn)).size;
    const distinctSkuCount = cart.length;
    const laneQuality = getLaneQuality(cart, maxRunFt);
    const candidate = {
        coverage,
        matCount,
        avgCoverage,
        laneWidthIn,
        widthTypeCount,
        distinctSkuCount,
        laneCount: laneQuality.laneCount || matCount,
        laneFillRangeFt: laneQuality.laneFillRangeFt || 0,
        lanePatternTypeCount: laneQuality.lanePatternTypeCount || 0,
        cart,
        isPartial: true
    };

    if (!best || isBetterPartialCart(candidate, best, targetSqFt)) {
        best = candidate;
    }
    }

    recurse(0);
    return best;
}

function isBetterPartialCart(candidate, currentBest, targetSqFt) {
    const coverageDiff = Math.abs(candidate.coverage - currentBest.coverage);
    const cleanLayoutTolerance = targetSqFt * (settings.partialCleanLayoutCoverageTolerance || 0.05);
    const coverageIsPracticallyTied = coverageDiff <= cleanLayoutTolerance;

    // For partial-coverage results, do not chase a few extra square feet if it creates
    // an awkward puzzle-piece layout. If coverage is practically tied, prefer the
    // cleaner physical plan first: fewer width types, fewer SKUs, fewer lanes, fewer mats.
    if (coverageIsPracticallyTied) {
    if ((candidate.widthTypeCount || 0) < (currentBest.widthTypeCount || 0)) return true;
    if ((candidate.widthTypeCount || 0) > (currentBest.widthTypeCount || 0)) return false;

    if ((candidate.distinctSkuCount || 0) < (currentBest.distinctSkuCount || 0)) return true;
    if ((candidate.distinctSkuCount || 0) > (currentBest.distinctSkuCount || 0)) return false;

    if ((candidate.laneCount || 0) < (currentBest.laneCount || 0)) return true;
    if ((candidate.laneCount || 0) > (currentBest.laneCount || 0)) return false;

    if ((candidate.lanePatternTypeCount || 0) < (currentBest.lanePatternTypeCount || 0)) return true;
    if ((candidate.lanePatternTypeCount || 0) > (currentBest.lanePatternTypeCount || 0)) return false;

    if ((candidate.laneFillRangeFt || 0) < (currentBest.laneFillRangeFt || 0)) return true;
    if ((candidate.laneFillRangeFt || 0) > (currentBest.laneFillRangeFt || 0)) return false;

    if (candidate.coverage > currentBest.coverage) return true;
    if (candidate.coverage < currentBest.coverage) return false;

    if (candidate.matCount < currentBest.matCount) return true;
    if (candidate.matCount > currentBest.matCount) return false;
    }

    // If one partial result provides meaningfully more coverage, prefer it.
    if (candidate.coverage > currentBest.coverage) return true;
    if (candidate.coverage < currentBest.coverage) return false;

    if (candidate.matCount < currentBest.matCount) return true;
    if (candidate.matCount > currentBest.matCount) return false;

    if ((candidate.widthTypeCount || 0) < (currentBest.widthTypeCount || 0)) return true;
    if ((candidate.widthTypeCount || 0) > (currentBest.widthTypeCount || 0)) return false;

    if ((candidate.distinctSkuCount || 0) < (currentBest.distinctSkuCount || 0)) return true;
    if ((candidate.distinctSkuCount || 0) > (currentBest.distinctSkuCount || 0)) return false;

    if ((candidate.laneCount || 0) < (currentBest.laneCount || 0)) return true;
    if ((candidate.laneCount || 0) > (currentBest.laneCount || 0)) return false;

    if ((candidate.lanePatternTypeCount || 0) < (currentBest.lanePatternTypeCount || 0)) return true;
    if ((candidate.lanePatternTypeCount || 0) > (currentBest.lanePatternTypeCount || 0)) return false;

    if ((candidate.laneFillRangeFt || 0) < (currentBest.laneFillRangeFt || 0)) return true;
    if ((candidate.laneFillRangeFt || 0) > (currentBest.laneFillRangeFt || 0)) return false;

    return candidate.avgCoverage > currentBest.avgCoverage;
}

function calculatePackedLaneWidth(cart, maxRunFt) {
    const matsByWidth = new Map();

    cart.forEach(item => {
    if (!matsByWidth.has(item.widthIn)) matsByWidth.set(item.widthIn, []);
    for (let i = 0; i < item.qty; i++) {
        matsByWidth.get(item.widthIn).push(item.lengthFt);
    }
    });

    let totalWidth = 0;

    matsByWidth.forEach((lengths, widthIn) => {
    const lanes = [];
    lengths.sort((a, b) => b - a).forEach(length => {
        let placed = false;
        for (let i = 0; i < lanes.length; i++) {
        if (lanes[i] + length <= maxRunFt + 0.0001) {
            lanes[i] += length;
            placed = true;
            break;
        }
        }
        if (!placed) lanes.push(length);
    });
    totalWidth += lanes.length * Number(widthIn);
    });

    return totalWidth;
}

function errorResult(status, warnings = [], targetSqFt = 0, requiresLayoutReview = false, showContactAssistance = false) {
    return {
    status,
    targetSqFt,
    recommendedCoverage: 0,
    totalWatts: 0,
    totalAmps: 0,
    fitSqFt: 0,
    fitPercent: 0,
    voltage: Number(document.getElementById('voltage').value),
    matCount: 0,
    layoutOrientation: null,
    laneWidthIn: 0,
    maxRunFt: 0,
    laneCapacityIn: 0,
    isSimpleRoom: false,
    roomLengthFt: null,
    roomWidthFt: null,
    cart: [],
    requiresLayoutReview,
    showContactAssistance,
    warnings
    };
}


function buildLayoutPreviewHtml(result) {
    if (!result.cart.length || !result.isSimpleRoom || !result.roomLengthFt || !result.roomWidthFt) return '';

    // Keep the room perspective fixed for both tabs:
    // horizontal axis = entered desired heated length, vertical axis = entered desired heated width.
    // The Recommended and Alternate tabs rotate only the mat direction inside the same room rectangle.
    const roomLengthFt = result.roomLengthFt;
    const roomWidthFt = result.roomWidthFt;
    const matsRunLengthwise = result.layoutOrientation === 'Lengthwise';
    const matRunFt = matsRunLengthwise ? roomLengthFt : roomWidthFt;
    const matLaneCapacityFt = matsRunLengthwise ? roomWidthFt : roomLengthFt;
    const lanes = packMatsIntoPreviewLanes(result.cart, matRunFt);
    const usedLaneFt = lanes.reduce((sum, lane) => sum + lane.widthIn / 12, 0);
    const uncoveredLaneFt = Math.max(0, matLaneCapacityFt - usedLaneFt);

    const viewWidth = 760;
    const padLeft = 62;
    const padRight = 24;
    const padTop = 42;
    const padBottom = 46;
    const drawingWidth = viewWidth - padLeft - padRight;
    const drawingHeight = Math.max(210, Math.min(370, drawingWidth * (roomWidthFt / roomLengthFt) * 1.18));
    const viewHeight = drawingHeight + padTop + padBottom;
    const sx = drawingWidth / roomLengthFt;
    const sy = drawingHeight / roomWidthFt;

    const heatedColor = '#900000';
    const heatedStroke = '#000';
    const unusedColor = '#e2e8f0';
    const roomStroke = '#334155';

    let svgParts = [];

    function addUnheatedRect(x, y, width, height, label = '') {
    if (width <= 0.5 || height <= 0.5) return;
    svgParts.push(`
        <rect x="${x}" y="${y}" width="${Math.max(1, width)}" height="${Math.max(1, height)}" fill="${unusedColor}" opacity="0.75" stroke="#cbd5e1" stroke-dasharray="5 4"></rect>
        ${label && width >= 54 && height >= 18 ? `<text x="${x + width / 2}" y="${y + height / 2 + 5}" text-anchor="middle" font-size="12" font-weight="800" fill="#64748b">${escapeHtml(label)}</text>` : ''}
    `);
    }

    if (matsRunLengthwise) {
    const topBottomUnheatedFt = uncoveredLaneFt / 2;
    let y = padTop + (topBottomUnheatedFt * sy);

    if (topBottomUnheatedFt > 0.01) {
        const stripHeight = topBottomUnheatedFt * sy;
        const stripLabel = `Approx. ${formatNumber(topBottomUnheatedFt)} ft unheated strip`;
        addUnheatedRect(padLeft, padTop, drawingWidth, stripHeight, stripLabel);
        addUnheatedRect(padLeft, padTop + drawingHeight - stripHeight, drawingWidth, stripHeight, stripLabel);
    }

    lanes.forEach((lane) => {
        const laneHeight = (lane.widthIn / 12) * sy;
        const laneUsedRunFt = lane.totalLengthFt;
        const sideUnheatedFt = Math.max(0, roomLengthFt - laneUsedRunFt) / 2;
        let x = padLeft + (sideUnheatedFt * sx);
        //const labelFont = Math.max(15, Math.min(22, laneHeight * 0.44));
        if (sideUnheatedFt > 0.01) {
        const sideWidth = sideUnheatedFt * sx;
        const sideLabel = `Approx. ${formatNumber(sideUnheatedFt)} ft`;
        addUnheatedRect(padLeft, y, sideWidth, laneHeight, sideLabel);
        addUnheatedRect(padLeft + drawingWidth - sideWidth, y, sideWidth, laneHeight, sideLabel);
        }

        lane.mats.forEach((mat) => {
        const w = mat.lengthFt * sx;
        const label = formatMatSizeLabel(mat);
        const labelCharCount = label.length;
        const maxFontByHeight = laneHeight * 0.38;
        const maxFontByWidth = w / (labelCharCount * 0.6);
        const labelFont = Math.max(7, Math.min(20, maxFontByHeight, maxFontByWidth));
        const canShowText = w >= 30 && laneHeight >= 16 && labelFont >= 7;

        svgParts.push(`
            <rect x="${x}" y="${y}" width="${Math.max(1, w)}" height="${Math.max(1, laneHeight)}" rx="8" fill="${heatedColor}" stroke="${heatedStroke}" stroke-width="1.8"></rect>
            ${canShowText ? `<text x="${x + w / 2}" y="${y + laneHeight / 2 + 7}" text-anchor="middle" font-size="${labelFont}" font-weight="800" fill="#fff">${escapeHtml(label)}</text>` : ''}
        `);
        x += w;
        });

        y += laneHeight;
    });
    } else {
    const leftRightUnheatedFt = uncoveredLaneFt / 2;
    let x = padLeft + (leftRightUnheatedFt * sx);

    if (leftRightUnheatedFt > 0.01) {
        const stripWidth = leftRightUnheatedFt * sx;
        const stripLabel = `Approx. ${formatNumber(leftRightUnheatedFt)} ft`;
        addUnheatedRect(padLeft, padTop, stripWidth, drawingHeight, stripLabel);
        addUnheatedRect(padLeft + drawingWidth - stripWidth, padTop, stripWidth, drawingHeight, stripLabel);
    }

    lanes.forEach((lane) => {
        const laneWidth = (lane.widthIn / 12) * sx;
        const laneUsedRunFt = lane.totalLengthFt;
        const topBottomUnheatedFt = Math.max(0, roomWidthFt - laneUsedRunFt) / 2;
        let y = padTop + (topBottomUnheatedFt * sy);
        //const labelFont = Math.max(14, Math.min(21, laneWidth * 0.34));
        if (topBottomUnheatedFt > 0.01) {
        const stripHeight = topBottomUnheatedFt * sy;
        const stripLabel = `Approx. ${formatNumber(topBottomUnheatedFt)} ft`;
        addUnheatedRect(x, padTop, laneWidth, stripHeight, stripLabel);
        addUnheatedRect(x, padTop + drawingHeight - stripHeight, laneWidth, stripHeight, stripLabel);
        }

        lane.mats.forEach((mat) => {
        const h = mat.lengthFt * sy;
        const label = formatMatSizeLabel(mat);
        const labelCharCount = label.length;
        const maxFontByWidth = laneWidth * 0.38;
        const maxFontByHeight = h / (labelCharCount * 0.6);
        const labelFont = Math.max(7, Math.min(20, maxFontByWidth, maxFontByHeight));
        const canShowText = h >= 30 && laneWidth >= 16 && labelFont >= 7;
        const cx = x + laneWidth / 2;
        const cy = y + h / 2;

        svgParts.push(`
            <rect x="${x}" y="${y}" width="${Math.max(1, laneWidth)}" height="${Math.max(1, h)}" rx="8" fill="${heatedColor}" stroke="${heatedStroke}" stroke-width="1.8"></rect>
            ${canShowText ? `<text x="${cx}" y="${cy + 6}" text-anchor="middle" font-size="${labelFont}" font-weight="800" fill="#FFF" transform="rotate(-90 ${cx} ${cy})">${escapeHtml(label)}</text>` : ''}
        `);
        y += h;
        });

        x += laneWidth;
    });
    }

    const roomLabel = `${formatNumber(roomLengthFt)} ft × ${formatNumber(roomWidthFt)} ft Area`;
    const runDirectionLabel = matsRunLengthwise
    ? `Mats run left to right along the ${formatNumber(roomLengthFt)} ft dimension`
    : `Mats run up and down along the ${formatNumber(roomWidthFt)} ft dimension`;

    const svg = `
    <svg viewBox="0 0 ${viewWidth} ${viewHeight}" role="img" aria-label="Suggested heating mat layout preview">
        <rect x="${padLeft}" y="${padTop}" width="${drawingWidth}" height="${drawingHeight}" rx="12" fill="#f8fafc" stroke="${roomStroke}" stroke-width="2.2"></rect>
        ${svgParts.join('')}
        <text x="${padLeft + drawingWidth / 2}" y="${padTop - 24}" text-anchor="middle" font-size="16" font-weight="800" fill="#1f2933">${escapeHtml(roomLabel)}</text>
        <text x="${padLeft + drawingWidth / 2}" y="${padTop + drawingHeight + 34}" text-anchor="middle" font-size="14" font-weight="700" fill="#475569">${escapeHtml(runDirectionLabel)}</text>
        <text x="${padLeft - 36}" y="${padTop + drawingHeight / 2}" text-anchor="middle" font-size="13" font-weight="700" fill="#64748b" transform="rotate(-90 ${padLeft - 36} ${padTop + drawingHeight / 2})">Area width</text>
        <text x="${padLeft + drawingWidth / 2}" y="${padTop + drawingHeight + 16}" text-anchor="middle" font-size="13" font-weight="700" fill="#64748b">Area length</text>
    </svg>
    `;

    return `
    <div class="layout-preview">
        <h3>${escapeHtml(result.layoutPreviewTitle || 'Suggested layout concept')}</h3>
        <p>For your convenience, here is the suggested layout. Full installation requires a thermostat and possibly additional accessories.</p>
        <div class="layout-svg-wrap">${svg}</div>
        <div class="layout-legend">
        <span class="legend-item"><span class="legend-swatch legend-heated"></span>Recommended mat coverage</span>
        <span class="legend-item"><span class="legend-swatch legend-unused"></span>Unheated / unused area</span>
        </div>
    </div>
    `;
}

function summarizePreviewLanes(lanes) {
    const counts = new Map();
    lanes.forEach(lane => counts.set(lane.widthIn, (counts.get(lane.widthIn) || 0) + 1));
    return Array.from(counts.entries())
    .sort((a, b) => b[0] - a[0])
    .map(([width, count]) => `${count} × ${width}" lane${count === 1 ? '' : 's'}`)
    .join(' + ');
}

function packMatsIntoPreviewLanes(cart, maxRunFt) {
    const individualMats = [];
    cart.forEach(item => {
    for (let i = 0; i < item.qty; i++) {
        individualMats.push({ ...item, qty: 1 });
    }
    });

    const byWidth = new Map();
    individualMats.forEach(mat => {
    if (!byWidth.has(mat.widthIn)) byWidth.set(mat.widthIn, []);
    byWidth.get(mat.widthIn).push(mat);
    });

    const lanes = [];
    Array.from(byWidth.keys()).sort((a, b) => b - a).forEach(widthIn => {
    const mats = byWidth.get(widthIn).sort((a, b) => b.lengthFt - a.lengthFt);
    const widthLanes = [];

    mats.forEach(mat => {
        let placed = false;
        for (let i = 0; i < widthLanes.length; i++) {
        if (widthLanes[i].totalLengthFt + mat.lengthFt <= maxRunFt + 0.0001) {
            widthLanes[i].mats.push(mat);
            widthLanes[i].totalLengthFt += mat.lengthFt;
            placed = true;
            break;
        }
        }
        if (!placed) {
        widthLanes.push({ widthIn, totalLengthFt: mat.lengthFt, mats: [mat] });
        }
    });

    lanes.push(...widthLanes);
    });

    return lanes;
}

function escapeHtml(value) {
    return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}


function buildSystemNoteHtml(result) {
    if (result.requiresLayoutReview) {
    return `
        <div class="system-note">
        <strong>Next step required</strong>
        Please contact us before ordering mats for this layout type. If you have a drawing, sketch, photo, or floor plan, send it along and we can review the space and recommend the right heating mat plan. You can also call <a href="tel:18003088057">800.308.8057</a>.
        </div>
    `;
    }

    if (!result.cart.length) return '';

    return `
    <div class="system-note">
        <strong style="color:#900000; font-size:18px;">Reminder</strong>
        A complete floor heating system also requires a compatible thermostat and may require additional accessories based on your installation. After adding to cart, you will be taken back to the product page where you can review these options.
    </div>
    `;
}

function getActiveLayoutResult(result) {
    if (!result || !result.layoutOptions || !result.layoutOptions.length) return result;
    return result.layoutOptions.find(option => option.optionKey === activeLayoutTab) || result.layoutOptions[0];
}

function buildLayoutTabsHtml(result) {
    if (!result || !result.layoutOptions || result.layoutOptions.length < 2) return '';
    const installType = result.installType || (result.layoutOptions.find(option => option.installType) || {}).installType || '';
    const resultProductLine = getResultProductLine(result);
    const showPerpendicularWarning = !!resultProductLine.supportsPerpendicularInstallNote && ['Nail Down', 'Nail Assist', 'Glue Assist'].includes(installType);
    const showThermostatPlacementPrompt = ['Glued', 'Floating'].includes(installType);
    let layoutWarning = '';

    if (showPerpendicularWarning) {
    layoutWarning = `
        <div class="naildown-tab-warning">
        <strong>${escapeHtml(installType)} Layout Requirement</strong>
        Mats must run perpendicular to the flooring boards. Confirm the direction before ordering.
        </div>
    `;
    } else if (showThermostatPlacementPrompt) {
    layoutWarning = `
        <div class="naildown-tab-warning">
        <strong>Choose the Layout Option closest to your thermostat location</strong>
        For Glued and Floating installations, choose the Layout Option that positions end of Heating Mats closest to the wall with thermostat.  This will simplify routing of mat leads to thermostat.
        </div>
    `;
    }

    return `
    <div class="layout-tab-row">
        ${layoutWarning}
        <div class="layout-tabs" role="tablist" aria-label="Heating mat layout options">
        ${result.layoutOptions.map(option => `
            <button class="layout-tab-btn ${option.optionKey === activeLayoutTab ? 'active' : ''}" type="button" data-layout-option="${option.optionKey}" role="tab" aria-selected="${option.optionKey === activeLayoutTab ? 'true' : 'false'}">
            ${escapeHtml(option.tabLabel || option.optionKey)}
            <small>${escapeHtml(getLayoutTabSubtext(option))}</small>
            </button>
        `).join('')}
        </div>
    </div>
    `;
}

function getLayoutTabSubtext(option) {
    if (!option || !option.layoutOrientation) return '';
    const runFt = option.layoutOrientation === 'Lengthwise' ? option.roomLengthFt : option.roomWidthFt;
    return option.cart && option.cart.length ? `Mats along ${formatNumber(runFt)} ft side` : 'Review needed';
}

function renderResults(result) {
    const displayResult = getActiveLayoutResult(result);

    if (displayResult.unsupportedInstallType) {
    resultsEl.innerHTML = `
        <div class="product-route-box">
        <h3>${escapeHtml(activeProductLine.unsupportedInstallHeadline || displayResult.status)}</h3>
        <p>${escapeHtml(activeProductLine.unsupportedInstallBody || '')}</p>
        <p class="selected-install"><strong>Selected install type:</strong> ${escapeHtml(displayResult.installType || '-')}</p>
        <div class="route-actions">
            <a class="route-link" href="${escapeHtml(getCalculatorLineUrl('warmstep'))}">Continue</a>
            <button class="secondary route-button-secondary" type="button" id="changeInstallTypeBtn">Change Install Type</button>
            <button class="secondary route-button-secondary" type="button" id="routeContactBtn">Contact ThermoSoft</button>
        </div>
        <p class="product-route-call"><strong>For Immediate Assistance, call us at <a href="tel:18003088057">800.308.8057</a>.</strong></p>
        </div>
    `;

    const changeInstallTypeBtn = document.getElementById('changeInstallTypeBtn');
    if (changeInstallTypeBtn) {
        changeInstallTypeBtn.addEventListener('click', function () {
        const installTypeEl = document.getElementById('installType');
        installTypeEl.value = '';
        if (requiredFieldsError) requiredFieldsError.classList.add('hidden');
        installTypeEl.focus();
        });
    }

    const routeContactBtn = document.getElementById('routeContactBtn');
    if (routeContactBtn) routeContactBtn.addEventListener('click', openLayoutHelpModal);
    return;
    }

    const isError = displayResult.cart.length === 0 && displayResult.status !== 'Valid recommendation';
    const isWarning = displayResult.status !== 'Valid recommendation';
    const cartRows = displayResult.cart.map(item => {
    const lineSqFt = item.lineCoverageSqFt || (item.qty * item.coverageSqFt);
    const lineWatts = calculateLineWatts(item);
    const lineAmps = calculateLineAmps(item);
    return `
        <tr>
        <td class="qty">${item.qty}</td>
        <td>${formatNumber(item.coverageSqFt)} sq ft</td>
        <td class="mat-size-label">${formatMatSizeLabel(item)}</td>
        <td>${item.voltage}V</td>
        <td>${formatNumber(lineSqFt)} sq ft</td>
        <td>${formatWholeNumber(lineWatts)} W</td>
        <td>${formatAmps(lineAmps)} A</td>
        </tr>
    `;
    }).join('');

    const warnings = displayResult.warnings?.length
    ? `<div class="warning-box">${displayResult.warnings.join('<br><br>')}</div>`
    : '';
    const layoutTabs = buildLayoutTabsHtml(result);
    const layoutPreview = buildLayoutPreviewHtml(displayResult);
    const systemNote = buildSystemNoteHtml(displayResult);
    const reviewHelpPrompt = displayResult.cart.length ? `
    <div class="result-help-prompt">
        <strong>Want ThermoSoft to review this before you order?</strong>
        <a href="#" class="layout-help-trigger">Contact Us</a> or call <a href="tel:18003088057">800.308.8057</a> and we can confirm your layout and product selection.
    </div>
    ` : '';
    const totalWatts = displayResult.totalWatts || calculateCartWatts(displayResult.cart);
    const totalAmps = displayResult.totalAmps || calculateCartAmps(displayResult.cart);

    const showStatusBar = displayResult.status !== 'Valid recommendation' && displayResult.status !== 'Closest physical fit';

    const productSwitchNotice = displayResult.productSwitchMessage ? `
    <div class="status warning">${escapeHtml(displayResult.productSwitchMessage)}</div>
    ` : '';

    const assistanceHtml = displayResult.showContactAssistance
        ? displayResult.voltage === 120
            ? `
            <div class="review-action-row voltage120">
                <button class="review-action-button" type="button" id="switchTo240Btn">
                Switch to 240V
                </button>
                <button class="review-action-button" type="button" id="contactAssistanceBtn">
                Contact Us for Assistance
                </button>
            </div>
            <p class="small-note">
                You can also call <a href="tel:18003088057">800.308.8057</a> to speak with one of our experts.
            </p>
            `
            : `
            <div class="review-action-row">
                <button class="review-action-button" type="button" id="contactAssistanceBtn">
                Contact Us for Assistance
                </button>
            </div>
            <p class="small-note">
                You can also call <a href="tel:18003088057">800.308.8057</a> to speak with one of our experts.
            </p>
            `
        : '';
        
    resultsEl.innerHTML = `
    ${productSwitchNotice}
    ${layoutTabs}
    ${showStatusBar ? `<div class="status ${isError ? 'error' : isWarning ? 'warning' : ''}">${displayResult.status}</div>` : ''}

    
    ${assistanceHtml}
    <div class="summary">
        <div class="metric"><span>Target</span><strong>${displayResult.targetSqFt ? formatNumber(displayResult.targetSqFt) : '-'} sq ft</strong></div>
        <div class="metric"><span>Recommended</span><strong>${displayResult.recommendedCoverage ? formatNumber(displayResult.recommendedCoverage) : '-'} sq ft</strong></div>
        <div class="metric"><span>Difference</span><strong>${formatDifference(displayResult)}</strong></div>
        <div class="metric"><span>Voltage</span><strong>${displayResult.voltage ? displayResult.voltage + 'V' : '-'}</strong></div>
        ${displayResult.cart.length ? `<div class="metric"><span>Total watts</span><strong>${formatWholeNumber(totalWatts)} W</strong></div>` : ''}
        ${displayResult.cart.length ? `<div class="metric"><span>Total amps</span><strong>${formatAmps(totalAmps)} A</strong></div>` : ''}
    </div>
    ${displayResult.cart.length ? `
        <div class="custom-rec-table">
        <strong style="color:#900000; font-size:18px;">What you will need for your Project: </strong>
        <table class="recommendation-table">
        <colgroup>
            <col class="qty-col">
            <col class="coverage-col">
            <col class="size-col">
            <col class="voltage-col">
            <col class="total-sqft-col">
            <col class="watts-col">
            <col class="amps-col">
        </colgroup>
        <thead>
            <tr>
            <th>Qty</th><th>Coverage</th><th>Size</th><th>Voltage</th><th>Total Sq Ft</th><th>Watts</th><th>Amps</th>
            </tr>
        </thead>
        <tbody>${cartRows}</tbody>
        </table>
        </div>
        ${layoutPreview}
        ${systemNote}
        ${reviewHelpPrompt}
        <button class="add-cart" id="addCartBtn" style="display:block;">Add Recommended Products to Cart</button>
    ` : ''}
    ${!displayResult.cart.length ? systemNote : ''}
    <div class="warnings">${warnings}</div>
    ${displayResult.cart.length ? '<div class="print-actions"><button class="print-button" type="button" id="printResultsBtn">Print Recommendation</button></div>' : ''}
    `;

    document.querySelectorAll('.layout-tab-btn').forEach(btn => {
    btn.addEventListener('click', function () {
        activeLayoutTab = this.getAttribute('data-layout-option') || 'recommended';
        renderResults(lastRecommendation || result);
    });
    });

    const contactAssistanceBtn = document.getElementById('contactAssistanceBtn');
    if (contactAssistanceBtn) {
    contactAssistanceBtn.addEventListener('click', openLayoutHelpModal);
    }

    const switchTo240Btn = document.getElementById('switchTo240Btn');
    if (switchTo240Btn) {
        switchTo240Btn.addEventListener('click', function() {
            const voltageEl = document.getElementById('voltage');
            if (voltageEl) {
                voltageEl.value = '240';
                document.getElementById('calcForm').dispatchEvent(new Event('submit', { cancelable: true }));
            }
        });
    }
 
    const contactThermoSoftLink = document.getElementById('contactThermoSoftLink');
    if (contactThermoSoftLink) {
    contactThermoSoftLink.addEventListener('click', function (e) {
        e.preventDefault();
        openLayoutHelpModal();
    });
    }

    const printResultsBtn = document.getElementById('printResultsBtn');
    if (printResultsBtn) {
    printResultsBtn.addEventListener('click', () => window.print());
    }

    const addCartBtn = document.getElementById('addCartBtn');
    if (addCartBtn) {
    //addCartBtn.addEventListener('click', () => addRecommendedCartToShopify(displayResult.cart));
    addCartBtn.addEventListener('click', () => addRecommendedCartToShopify(displayResult.cart, displayResult.productLineKey));
    }
}

function calculateLineWatts(item) {
    return (Number(item.watts) || 0) * (Number(item.qty) || 0);
}

function calculateLineAmps(item) {
    const qty = Number(item.qty) || 0;
    if (item.amps !== undefined && item.amps !== null && item.amps !== '') {
    return (Number(item.amps) || 0) * qty;
    }
    const volts = Number(item.voltage) || 0;
    return volts ? calculateLineWatts(item) / volts : 0;
}

function calculateCartWatts(cart) {
    return (cart || []).reduce((sum, item) => sum + calculateLineWatts(item), 0);
}

function calculateCartAmps(cart) {
    return (cart || []).reduce((sum, item) => sum + calculateLineAmps(item), 0);
}

function formatWidthFt(widthIn) {
    const widthFt = Number(widthIn) / 12;
    return `${formatNumber(widthFt)} ft`;
}

function formatMatSizeLabel(item) {
    const widthFt = (Number(item.widthIn) || 0) / 12;
    const lengthFt = Number(item.lengthFt) || 0;
    return `${widthFt.toFixed(1)} Ft X ${lengthFt.toFixed(1)} Ft`;
}

function formatWholeNumber(value) {
    return Math.round(Number(value) || 0).toLocaleString();
}

function formatAmps(value) {
    return (Number(value) || 0).toFixed(2).replace(/\.00$/, '');
}

function formatNumber(value) {
    return Number(value).toFixed(1).replace('.0', '');
}

function formatFit(result) {
    if (!result.recommendedCoverage) return '-';
    const sqFt = result.fitSqFt;
    const pct = result.fitPercent * 100;
    if (Math.abs(sqFt) < 0.01 && Math.abs(pct) < 0.01) return 'None';
    return `${sqFt >= 0 ? '+' : ''}${formatNumber(sqFt)} / ${pct >= 0 ? '+' : ''}${pct.toFixed(1)}%`;
}

function formatDifference(result) {
    if (!result.recommendedCoverage) return '-';
    const pct = result.fitPercent * 100;
    if (Math.abs(pct) < 0.01) return 'None';
    return `${pct >= 0 ? '+' : ''}${pct.toFixed(1)}%`;
}

// async function addRecommendedCartToShopify(cart) {
//     const items = cart.map(item => ({
//     id: item.variantId,
//     quantity: item.qty
//     }));

//     alert('Mock add-to-cart: ' + JSON.stringify(items));
// }
// custom add to cart start
async function addRecommendedCartToShopify(cart, productLineKey) {
  if (!cart || !cart.length) return;

  const items = cart
    .filter(item => item.variantId)
    .map(item => ({
      id: item.variantId,
      quantity: item.qty
    }));

  if (!items.length) {
    alert('Sorry, we were unable to add these items to your cart. Please contact us for assistance.');
    return;
  }

  const addCartBtn = document.getElementById('addCartBtn');
  const originalLabel = addCartBtn ? addCartBtn.textContent : '';
  if (addCartBtn) {
    addCartBtn.disabled = true;
    addCartBtn.textContent = 'Adding to cart...';
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => null);
      throw new Error((errorData && errorData.description) || 'Unable to add items to cart.');
    }

    // Determine dominant mat width from cart
    const widths = [...new Set(items.map(item => {
    const product = cart.find(c => String(c.variantId) === String(item.id));
    return product ? product.widthIn : null;
    }).filter(Boolean))];

    const voltage = cart[0]?.voltage; 
    refreshCartCount();
    refreshCartDrawer();
    if (productLineKey === 'thermofloor') {
    window.location.href =
        '/collections/thermofloor-mats?filter.p.m.custom.voltage_size=120V+1.5%27+Wide&open_cart=true';
    } else {
    window.location.href =
        '/collections/warmstep-mats?filter.p.m.custom.voltage_size=120V+1.5%27+Wide&open_cart=true';
    }
 

  } catch (err) {
    if (addCartBtn) {
      addCartBtn.disabled = false;
      addCartBtn.textContent = originalLabel;
    }
    alert('Sorry, something went wrong adding these items to your cart. Please try again or contact us for assistance.\n\n' + err.message);
  }
}
// custom add to cart end


function openLayoutHelpModal() {
    document.getElementById('layoutHelpModal').classList.add('active');
    document.getElementById('layoutHelpModal').setAttribute('aria-hidden', 'false');
    setTimeout(() => document.getElementById('layoutName').focus(), 0);
}

function closeLayoutHelpModal() {
    document.getElementById('layoutHelpModal').classList.remove('active');
    document.getElementById('layoutHelpModal').setAttribute('aria-hidden', 'true');
}

// function handleLayoutHelpSubmit(e) {
//     e.preventDefault();

//     const name = document.getElementById('layoutName').value.trim();
//     const email = document.getElementById('layoutEmail').value.trim();
//     const phone = document.getElementById('layoutPhone').value.trim();
//     const details = document.getElementById('layoutDetails').value.trim();
//     const inputs = readInputs();

//     const projectLines = buildProjectEmailLines(inputs);
//     const recommendationLines = buildRecommendationEmailLines(lastRecommendation);

//     const subject = 'Floor Heating Layout Review Request';
//     const body = [
//     'Floor Heating Layout Review Request',
//     '',
//     'Contact Information',
//     `Name: ${name}`,
//     `Email: ${email}`,
//     `Phone: ${phone}`,
//     '',
//     'Layout Details',
//     details || 'No additional details provided.',
//     '',
//     'Project Details',
//     ...projectLines,
//     '',
//     'Current Calculator Recommendation',
//     ...recommendationLines,
//     '',
//     'Please attach the drawing, sketch, photo, or marked-up floor plan before sending.'
//     ].join('\n');

//     window.location.href = `mailto:sales@thermosoft.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
//     closeLayoutHelpModal();
// }

async function handleLayoutHelpSubmit(e) {
    e.preventDefault();

    const submitBtn = document.getElementById('layoutSubmitBtn');

    const name = document.getElementById('layoutName').value.trim();
    const email = document.getElementById('layoutEmail').value.trim();
    const phone = document.getElementById('layoutPhone').value.trim();
    const details = document.getElementById('layoutDetails').value.trim();

    const phoneDigits = phone.replace(/\D/g, '');
    const phoneValid = phoneDigits.length === 11 && phoneDigits.startsWith('1');
    if (!name || !email || !phone || !phoneValid) {
        const existingError = document.querySelector('#layoutHelpModal .form-error-msg');
        if (existingError) existingError.remove();
        const modalBody = document.querySelector('#layoutHelpModal .modal-body');
        if (modalBody) {
            const div = document.createElement('div');
            div.className = 'form-error-msg';
            div.style.cssText = 'color:#d84a2b; background:#fef2f2; border:1px solid #fecaca; border-radius:8px; padding:12px 16px; margin-bottom:12px; font-size:14px;';
            div.textContent = !name || !email || !phone
                ? 'Please complete all required fields.'
                : 'Please enter a valid US phone number (+1 followed by 10 digits).';
            modalBody.insertBefore(div, modalBody.firstChild);
        }
        return;
    }

    const inputs = readInputs();

    const payload = {
        name,
        email,
        phone,
        details,

        projectDetails: buildProjectEmailLines(inputs).join('\n'),
        recommendation: buildRecommendationEmailLines(lastRecommendation).join('\n'),

        calculatorType: activeProductLine?.name || '',
        submittedAt: new Date().toISOString()
    };

    try {
        if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Submitting...';
        }

        // Optional Cloudinary upload
        const fileInput = document.getElementById('layoutAttachment');

        if (fileInput && fileInput.files.length) {
            submitBtn.textContent = 'Uploading File...';

            const cloudinaryFormData = new FormData();
            cloudinaryFormData.append('file', fileInput.files[0]);
            cloudinaryFormData.append('upload_preset', 'calculator_uploads');

            const cloudinaryResponse = await fetch(
                'https://api.cloudinary.com/v1_1/d84eckxt/upload',
                {
                    method: 'POST',
                    body: cloudinaryFormData
                }
            );

            if (!cloudinaryResponse.ok) {
                throw new Error('File upload failed.');
            }

            const cloudinaryData = await cloudinaryResponse.json();

            payload.fileUrl = cloudinaryData.secure_url;
            payload.fileName = fileInput.files[0].name;
        }

        submitBtn.textContent = 'Sending Request...';

        const zapierFormData = new FormData();

        Object.entries(payload).forEach(([key, value]) => {
            zapierFormData.append(key, value ?? '');
        });

        const response = await fetch(
            'https://hooks.zapier.com/hooks/catch/17987739/4bjrq40/',
            {
                method: 'POST',
                body: zapierFormData
            }
        );

        const responseText = await response.text();
         
            //console.log('Zapier Payload JSON');
            // console.log(JSON.stringify(payload, null, 2));
        if (!response.ok) {
            throw new Error(`Status ${response.status}: ${responseText}`);
        }

        // alert('Thank you! Your request has been submitted.');

        // document.getElementById('layoutHelpForm').reset();
        // closeLayoutHelpModal();
        document.getElementById('layoutHelpForm').reset();
        // Hide modal header
        const modalHeader = document.querySelector('#layoutHelpModal .modal-header');
        if (modalHeader) modalHeader.style.display = 'none';

        // Show inline success message inside modal
        const modalBody = document.querySelector('#layoutHelpModal .modal-body');
        if (modalBody) {
            modalBody.innerHTML = `
                <div style="text-align:center; padding: 2rem 1rem;">
                    <div style="font-size: 48px; margin-bottom: 1rem;">✓</div>
                    <h3 style="color: #1f2933; margin-bottom: 0.5rem;">Request Submitted!</h3>
                    <p style="color: #64748b; margin-bottom: 1.5rem;">Thank you! Your request has been sent to our team. We'll be in touch shortly.</p>
                    <p style="color: #94a3b8; font-size: 13px;">This window will close automatically...</p>
                </div>
            `;
        }

        // Auto close after 5 seconds
        setTimeout(function () {
            closeLayoutHelpModal();
            // Restore the form HTML after closing so it works again if reopened
            setTimeout(function () {
                location.reload();
            }, 400);
        }, 5000);
        // Show inline success message inside modal END

    } catch (error) {
        // console.error('Submission Error:', error);
        // alert(error.message || 'Unable to submit your request. Please try again.');
        // Remove any existing error message first
        const existingError = document.querySelector('#layoutHelpModal .form-error-msg');
        if (existingError) existingError.remove();

        // Show inline error at top of form
        const modalBody = document.querySelector('#layoutHelpModal .modal-body');
        if (modalBody) {
            const div = document.createElement('div');
            div.className = 'form-error-msg';
            div.style.cssText = 'color:#d84a2b; background:#fef2f2; border:1px solid #fecaca; border-radius:8px; padding:12px 16px; margin-bottom:12px; font-size:14px;';
            div.textContent = error.message || 'Unable to submit your request. Please try again.';
            modalBody.insertBefore(div, modalBody.firstChild);
        }
         // Show inline error at top of form END


    } finally {
        if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Request';
        }
    }
}

function buildProjectEmailLines(inputs) {
    const lines = [
    `Room shape: ${inputs.roomShape}`,
    `Voltage: ${inputs.voltage || '-'}V`,
    `Install type: ${inputs.installType || '-'}`
    ];

    if (inputs.roomShape === 'Open Floor Plan/Rectangular with No Obstacles') {
    lines.push(`Heated length: ${inputs.heatedLengthFt || '-'} ft`);
    lines.push(`Heated width: ${inputs.heatedWidthFt || '-'} ft`);
    if (inputs.heatedLengthFt && inputs.heatedWidthFt) {
        lines.push(`Calculated heated area: ${formatNumber(inputs.heatedLengthFt * inputs.heatedWidthFt)} sq ft`);
    }
    } else {
    lines.push(`Estimated heated area: ${inputs.estimatedSqFt || '-'} sq ft`);
    // lines.push(`Longest straight heated run: ${inputs.longestStraightRunFt || '-'} ft`);
    // lines.push(`Narrowest usable heated width: ${inputs.narrowestHeatedWidthIn || '-'} in`);
    }

    return lines;
}

function buildRecommendationEmailLines(result) {
    if (!result) {
    return ['No recommendation generated yet.'];
    }

    result = getActiveLayoutResult(result);

    const lines = [
    `Status: ${result.status}`,
    `Target: ${result.targetSqFt ? formatNumber(result.targetSqFt) : '-'} sq ft`,
    `Recommended coverage: ${result.recommendedCoverage ? formatNumber(result.recommendedCoverage) : '-'} sq ft`,
    `Difference: ${formatDifference(result)}`,
    `Total watts: ${result.totalWatts ? formatWholeNumber(result.totalWatts) : '-'} W`,
    `Total amps: ${result.totalAmps ? formatAmps(result.totalAmps) : '-'} A`
    ];

    if (result.cart && result.cart.length) {
    lines.push('Cart:');
    result.cart.forEach(item => {
        lines.push(`- ${item.qty} × ${item.sku} (${item.widthIn}\" wide × ${item.lengthFt} ft, ${formatNumber(item.lineCoverageSqFt)} sq ft)`);
    });
    } else {
    lines.push('Cart: No cart recommendation generated.');
    }

    return lines;
}

function resetForm() {
    document.getElementById('calcForm').reset();
    lastRecommendation = null;
    activeLayoutTab = 'recommended';
    if (requiredFieldsError) requiredFieldsError.classList.add('hidden');
    updateFieldVisibility();
    renderEmptyResults();
}

applyStateFromQueryParams();
updateFieldVisibility();

if (shouldAutoGenerateFromQueryParams()) {
    document.getElementById('calcForm').dispatchEvent(new Event('submit', { cancelable: true }));
} 



document.querySelectorAll('.calculator .field label svg').forEach(icon => {

    icon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const tooltip = this.nextElementSibling;

        document.querySelectorAll('.calculator .field p.show').forEach(t => {
            if (t !== tooltip) t.classList.remove('show');
        });

        tooltip.classList.toggle('show');
    });

});

document.addEventListener('click', function () {
    document.querySelectorAll('.calculator .field p.show').forEach(t => {
        t.classList.remove('show');
    });
});

// window.addEventListener('pageshow', function (event) {
//     // Fires on normal load and when returning via browser Back
//     refreshCartCount();
//     refreshCartDrawer();
// });
window.addEventListener('pageshow', () => {
    refreshCartCount();
    refreshCartDrawer();
});
async function refreshCartCount() {
  try {
    const response = await fetch('/cart.js', {
      cache: 'no-store'
    });

    const cart = await response.json();

    document.querySelectorAll('.thb-item-count').forEach(el => {
      el.textContent = cart.item_count;
    });

    //console.log('Cart count updated:', cart.item_count);

  } catch (error) {
    console.error('Cart count refresh failed:', error);
  }
}
async function refreshCartDrawer() {
  try {
    // Fetch updated cart HTML from Shopify
    const response = await fetch('/cart?view=drawer', {
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    if (!response.ok) return;

    // Try to trigger the theme's built-in cart refresh event
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    window.dispatchEvent(new CustomEvent('cart:refresh'));

    // Also try theme-specific events used by common Shopify themes
    document.dispatchEvent(new CustomEvent('theme:cart:update'));
    document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));

    // Force re-fetch via the cart drawer toggle if it has a src attribute
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents({ preventDefault: () => {} });
    }

  } catch (error) {
    console.error('Cart drawer refresh failed:', error);
  }
}
